// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";

// function AddRetailer({ toggleSidebar }) {
//   const [loading, setLoading] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [suppliers, setSuppliers] = useState([]);
//   const [productTypes, setProductTypes] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const toast = useToast();
//   const navigate = useNavigate();

//   // Initialize form data
//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: new Date().toISOString().split("T")[0],
//     supplier_id: "",
//     return_type: "",
//     pure: "",
//     amount: "",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     total_amount: "0.000",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: "",
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//   });

//   // Fetch initial data on component mount
//   useEffect(() => {
//     toggleSidebar();
//     fetchInitialData();
//   }, []);

//   const fetchInitialData = async () => {
//     try {
//       // Fetch retailer ID
//       const idResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
//       );
//       setGenerateNumber(idResponse.data.retailer_id || "");
//       setFormData((prev) => ({
//         ...prev,
//         retailer_id: idResponse.data.retailer_id || "",
//       }));

//       // Fetch supplier data
//       const supplierResponse = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(supplierResponse.data?.data || []);

//       // Fetch product types
//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);

//       // Set default opening to 0 until supplier is selected
//       setFormData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form data", 3000, "topRight");
//     }
//   };

//   // Fetch supplier-specific opening balance (sum of close values for the supplier)
//   const fetchSupplierCloseValue = async (supplierId) => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//       const supplierRetailers = response.data.data.filter(
//         (retailer) => retailer.supplier_id === supplierId
//       );
//       const totalOpening = supplierRetailers
//         .reduce((sum, retailer) => sum + parseFloat(retailer.close || 0), 0)
//         .toFixed(3);
//       return totalOpening;
//     } catch (error) {
//       console.error("Error fetching supplier retailers:", error);
//       // toast.error("Failed to fetch supplier opening balance", 3000, "topRight");
//       return "0.000";
//     }
//   };

//   // Handle supplier selection and set opening balance
//   const handleSupplierSelect = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setShowDropdown(false);

//     // Fetch supplier-specific opening balance
//     const openingBalance = await fetchSupplierCloseValue(supplier.supplier_id);
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: {
//         supplier_id: supplier.supplier_id,
//         name: supplier.name,
//         mobile: supplier.mobile,
//         address: supplier.address,
//       },
//       opening: openingBalance,
//     }));
//     console.log(
//       "Opening balance for supplier",
//       supplier.supplier_id,
//       ":",
//       openingBalance
//     );
//   };

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//       opening: "0.000",
//     }));
//   };

//   // Calculate pure and total_amount for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight);
//       const purity = parseFloat(newItem.purity);
//       const quantity = parseFloat(newItem.quantity);

//       if (!isNaN(weight) && !isNaN(purity) && !isNaN(quantity)) {
//         if (purity > 100) {
//           toast.error("Purity cannot exceed 100%", 3000, "topRight");
//           setNewItem((prev) => ({ ...prev, purity: "" }));
//           return;
//         }
//         const singlePure = (weight * purity) / 100;
//         pure = (quantity * singlePure).toFixed(3);
//         total_amount = (quantity * singlePure).toFixed(3);
//       }
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, toast]);

//   // Calculate total_pure and total_amount for items
//   useEffect(() => {
//     const totalPure = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     const totalAmount = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
//       .toFixed(3);

//     setFormData((prev) => ({
//       ...prev,
//       total_pure: totalPure,
//       total_amount: totalAmount,
//     }));
//     console.log(
//       "Total Pure calculated:",
//       totalPure,
//       "Total Amount:",
//       totalAmount,
//       "Items:",
//       formData.items
//     );
//   }, [formData.items]);

//   // Calculate current (opening + total_pure)
//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     const totalPure = parseFloat(formData.total_pure) || 0;
//     const current = (opening + totalPure).toFixed(3);
//     setFormData((prev) => ({ ...prev, current }));
//     console.log("Current calculated:", current, { opening, totalPure });
//   }, [formData.opening, formData.total_pure]);

//   // Calculate closing balance
//   useEffect(() => {
//     const totalPure = parseFloat(formData.total_pure) || 0;
//     let close = totalPure.toFixed(3); // Default closing to total_pure

//     if (formData.return_type === "Pure") {
//       const pure = parseFloat(formData.pure) || 0;
//       if (pure > totalPure) {
//         toast.error("Pure value cannot exceed Total Pure", 3000, "topRight");
//         setFormData((prev) => ({ ...prev, pure: "" }));
//         close = totalPure.toFixed(3);
//       } else {
//         close = (totalPure - pure).toFixed(3);
//       }
//       // Reset amount input when return_type is Pure
//       if (formData.amount !== "") {
//         setFormData((prev) => ({ ...prev, amount: "" }));
//       }
//     } else if (formData.return_type === "Amount") {
//       const amount = parseFloat(formData.amount) || 0;
//       if (amount > totalPure) {
//         toast.error("Amount cannot exceed Total Pure", 3000, "topRight");
//         setFormData((prev) => ({ ...prev, amount: "" }));
//         close = totalPure.toFixed(3);
//       } else {
//         close = (totalPure - amount).toFixed(3);
//       }
//       // Reset pure input when return_type is Amount
//       if (formData.pure !== "") {
//         setFormData((prev) => ({ ...prev, pure: "" }));
//       }
//     }

//     setFormData((prev) => ({ ...prev, close }));
//     console.log("Closing calculated:", close, {
//       totalPure,
//       pure: formData.pure,
//       amount: formData.amount,
//       return_type: formData.return_type,
//     });
//   }, [
//     formData.total_pure,
//     formData.pure,
//     formData.amount,
//     formData.return_type,
//     toast,
//   ]);

//   // Reset type when item is "Bar"
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...prev, type: "" }));
//     }
//   }, [newItem.item]);

//   // Handle adding a new item
//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...formData.items,
//       {
//         id: formData.items.length + 1,
//         retailer_id: formData.retailer_id,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 0,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//       },
//     ];

//     setFormData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   // Validate new item
//   const validateItem = () => {
//     if (!newItem.item) {
//       toast.error("Please select an item", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item !== "Bar" && !newItem.type) {
//       toast.error("Please select a type", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return false;
//     }
//     if (
//       !newItem.purity ||
//       parseFloat(newItem.purity) <= 0 ||
//       parseFloat(newItem.purity) > 100
//     ) {
//       toast.error("Please enter a valid purity (0-100%)", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item === "Others" && !newItem.other_name) {
//       toast.error("Please enter a name for 'Others'", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Reset new item form
//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: "",
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//     });
//     setEditingItemId(null);
//   };

//   // Handle removing an item
//   const handleRemoveItem = (itemId) => {
//     const updatedItems = formData.items
//       .filter((item) => item.id !== itemId)
//       .map((item, index) => ({ ...item, id: index + 1 }));
//     setFormData((prev) => ({ ...prev, items: updatedItems }));
//   };

//   // Handle editing an item
//   const handleEditItem = (itemId) => {
//     const itemToEdit = formData.items.find((item) => item.id === itemId);
//     if (itemToEdit) {
//       setNewItem({
//         item: itemToEdit.item,
//         category: itemToEdit.category,
//         other_name: itemToEdit.other_name,
//         type: itemToEdit.type,
//         quantity: itemToEdit.quantity.toString(),
//         weight: itemToEdit.weight.toString(),
//         purity: itemToEdit.purity.toString(),
//         pure: itemToEdit.pure.toFixed(3),
//         total_amount: itemToEdit.total_amount.toFixed(3),
//       });
//       setEditingItemId(itemId);
//     }
//   };

//   // Handle updating an item
//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updatedItems = formData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//             ...item,
//             item: newItem.item,
//             retailer_id: formData.retailer_id,
//             category: newItem.category,
//             other_name: newItem.other_name,
//             type: newItem.type,
//             quantity: parseFloat(newItem.quantity) || 0,
//             weight: parseFloat(newItem.weight) || 0,
//             purity: parseFloat(newItem.purity) || 0,
//             pure: parseFloat(newItem.pure) || 0,
//             total_amount: parseFloat(newItem.total_amount) || 0,
//           }
//         : item
//     );

//     setFormData((prev) => ({ ...prev, items: updatedItems }));
//     resetNewItem();
//   };

//   // Validate form before save or print
//   const validateForm = () => {
//     if (!formData.retailer_id) {
//       toast.error("Retailer ID is required", 3000, "topRight");
//       return false;
//     }
//     if (!formData.retailer_date) {
//       toast.error("Retailer date is required", 3000, "topRight");
//       return false;
//     }
//     if (!formData.supplier_id) {
//       toast.error("Please select a supplier", 3000, "topRight");
//       return false;
//     }
//     if (formData.items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Pure" &&
//       (!formData.pure || parseFloat(formData.pure) < 0)
//     ) {
//       toast.error("Please enter a valid pure value", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Amount" &&
//       (!formData.amount || parseFloat(formData.amount) < 0)
//     ) {
//       toast.error("Please enter a valid amount", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Prepare payload for API
//   const preparePayload = () => {
//     let payload = {
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       supplier_id: formData.supplier_id,
//       return_type: formData.return_type,
//       pure: parseFloat(formData.pure) || 0,
//       amount: parseFloat(formData.amount) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       total_amount: parseFloat(formData.total_amount) || 0,
//       items: formData.items.map((item) => ({
//         category: item.category,
//         quantity: parseFloat(item.quantity) || 0,
//         item: item.item,
//         weight: parseFloat(item.weight) || 0,
//         type: item.type,
//         other_name: item.other_name || "",
//         percentage: parseFloat(item.purity) || 0,
//         pure: parseFloat(item.pure) || 0,
//         total_amount: parseFloat(item.total_amount) || 0,
//         retailer_id: formData.retailer_id,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.amount = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     } else {
//       payload.pure = 0;
//       payload.amount = 0;
//     }

//     console.log("Payload prepared:", payload);
//     return payload;
//   };

//   // Handle saving the retailer
//   const handleSave = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const response = await axios.post(
//         `${ApiUrl}/Api/retailer_details.php`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Retailer saved successfully!", 3000, "topRight");
//         console.log("Saved retailer response:", response.data);
//         // Fetch new retailer ID and reset form, retaining supplier and setting opening to the saved close
//         const newRetailerIdResponse = await axios.get(
//           `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
//         );
//         const newRetailerId = newRetailerIdResponse.data.retailer_id || "";
//         setGenerateNumber(newRetailerId);
//         setFormData((prev) => ({
//           ...prev,
//           retailer_id: newRetailerId,
//           retailer_date: new Date().toISOString().split("T")[0],
//           return_type: "",
//           pure: "",
//           amount: "",
//           opening: prev.close, // Set opening to the just saved close
//           current: "0.000",
//           close: "0.000",
//           total_pure: "0.000",
//           total_amount: "0.000",
//           items: [],
//           supplier_id: prev.supplier_id,
//           supplier_details: prev.supplier_details,
//         }));
//         setNewItem({
//           item: "",
//           category: "",
//           other_name: "",
//           type: "",
//           quantity: "",
//           weight: "",
//           purity: "",
//           pure: "0.000",
//           total_amount: "0.000",
//         });
//         setEditingItemId(null);
//         navigate("/retailers");
//       } else {
//         toast.error(
//           response.data.message || "Failed to save retailer",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       toast.error(
//         error.response?.data?.message || "Failed to save retailer",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle printing the retailer
//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const response = await axios.post(
//         `${ApiUrl}/Api/retailer_details.php`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Retailer saved successfully!", 3000, "topRight");
//         console.log("Print retailer response:", response.data);
//         setShowModal(true);
//       } else {
//         toast.error(
//           response.data.message || "Failed to save retailer for print",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Print error:", error);
//       toast.error(
//         error.response?.data?.message || "Failed to save and print retailer",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear form
//   const handleClear = () => {
//     setFormData((prev) => ({
//       ...prev,
//       retailer_id: generateNumber,
//       retailer_date: new Date().toISOString().split("T")[0],
//       return_type: "",
//       pure: "",
//       amount: "",
//       opening: prev.opening, // Retain opening balance
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       total_amount: "0.000",
//       items: [],
//       supplier_id: prev.supplier_id,
//       supplier_details: prev.supplier_details,
//     }));
//     resetNewItem();
//     setSearchTerm(
//       selectedSupplier
//         ? `${selectedSupplier.supplier_id} - ${selectedSupplier.name}`
//         : ""
//     );
//   };

//   // Modal controls
//   const closeModal = () => {
//     setShowModal(false);
//     navigate(`/retailer-bill/${formData.retailer_id}`);
//   };

//   return (
//     <div className="container-fluid py-2">
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}
//       {/* Form Header */}
//       <div className="row">
//         <div className="col-lg-3">
//           <div className="card p-2">
//             <div className="row">
//               <div className="col-md-6">
//                 <label className="form-label">Retailer ID</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={generateNumber}
//                   readOnly
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label className="form-label">Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={formData.retailer_date}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       retailer_date: e.target.value,
//                     })
//                   }
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-9">
//           <div className="card p-2">
//             <div className="row g-3">
//               <div className="col-md-3 position-relative">
//                 <label className="form-label">Supplier</label>
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search supplier..."
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setShowDropdown(true);
//                     }}
//                     onFocus={() => setShowDropdown(true)}
//                   />
//                   {searchTerm && (
//                     <button
//                       className="btn btn-outline-secondary h-75"
//                       type="button"
//                       onClick={clearSupplier}
//                     >
//                       <i className="bi bi-x"></i>
//                     </button>
//                   )}
//                 </div>
//                 {showDropdown && suppliers.length > 0 && (
//                   <div className="dropdown-menu show w-100">
//                     {suppliers
//                       .filter(
//                         (supplier) =>
//                           supplier.supplier_id
//                             .toLowerCase()
//                             .includes(searchTerm.toLowerCase()) ||
//                           supplier.name
//                             .toLowerCase()
//                             .includes(searchTerm.toLowerCase())
//                       )
//                       .map((supplier) => (
//                         <button
//                           key={supplier.supplier_id}
//                           className="dropdown-item"
//                           onClick={() => handleSupplierSelect(supplier)}
//                           type="button"
//                         >
//                           {supplier.supplier_id} - {supplier.name}
//                         </button>
//                       ))}
//                   </div>
//                 )}
//               </div>
//               <div className="col-md-3">
//                 <label className="form-label">Supplier Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   value={
//                     formData.supplier_details?.name ||
//                     selectedSupplier?.name ||
//                     ""
//                   }
//                   disabled
//                 />
//               </div>
//               <div className="col-md-3">
//                 <label className="form-label">Mobile</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   value={
//                     formData.supplier_details?.mobile ||
//                     selectedSupplier?.mobile ||
//                     ""
//                   }
//                   disabled
//                 />
//               </div>
//               <div className="col-md-3">
//                 <label className="form-label">Address</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   value={
//                     formData.supplier_details?.address ||
//                     selectedSupplier?.address ||
//                     ""
//                   }
//                   disabled
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Item Entry Form */}
//       <div className="card p-2 mt-1">
//         <div className="row g-3">
//           <div className="col-md-2">
//             <label className="form-label">Item</label>
//             <select
//               className="form-select"
//               value={newItem.item}
//               onChange={(e) =>
//                 setNewItem({
//                   ...newItem,
//                   item: e.target.value,
//                   type: e.target.value === "Bar" ? "" : newItem.type,
//                 })
//               }
//             >
//               <option value="">Select Item</option>
//               <option value="Bar">Bar</option>
//               <option value="Jewels">Jewels</option>
//               <option value="Others">Others</option>
//             </select>
//           </div>

//           {newItem.item === "Others" && (
//             <div className="col-md-2">
//               <label className="form-label">Others Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Others Name"
//                 value={newItem.other_name}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, other_name: e.target.value })
//                 }
//               />
//             </div>
//           )}

//           <div className="col-md-2">
//             <label className="form-label">Category</label>
//             <select
//               className="form-select"
//               value={newItem.category}
//               onChange={(e) =>
//                 setNewItem({ ...newItem, category: e.target.value })
//               }
//             >
//               <option value="">Select Category</option>
//               <option value="Gold">Gold</option>
//               <option value="Silver">Silver</option>
//             </select>
//           </div>
//           <div className="col-md-2">
//             <label className="form-label">Type</label>
//             <select
//               className="form-select"
//               value={newItem.type}
//               onChange={(e) => setNewItem({ ...newItem, type: e.target.value })}
//               disabled={newItem.item === "Bar"}
//             >
//               <option value="">Select Type</option>
//               {Array.isArray(productTypes) &&
//                 productTypes.map((item) => (
//                   <option key={item._id} value={item.type}>
//                     {item.type}
//                   </option>
//                 ))}
//             </select>
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Qty</label>
//             <input
//               type="text"
//               inputMode="numeric"
//               pattern="[0-9]*"
//               maxLength="5"
//               className="form-control"
//               placeholder="Quantity"
//               value={newItem.quantity}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d*$/.test(value)) {
//                   setNewItem({ ...newItem, quantity: value });
//                 }
//               }}
//             />
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Weight (g)</label>
//             <input
//               type="text"
//               inputMode="decimal"
//               className="form-control"
//               placeholder="Weight"
//               value={newItem.weight}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d*\.?\d*$/.test(value)) {
//                   setNewItem({ ...newItem, weight: value });
//                 }
//               }}
//             />
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Purity (%)</label>
//             <input
//               type="text"
//               inputMode="decimal"
//               className="form-control"
//               placeholder="Purity"
//               value={newItem.purity}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
//                   const numericValue = parseFloat(value);
//                   if (
//                     value === "" ||
//                     (!isNaN(numericValue) && numericValue <= 100)
//                   ) {
//                     setNewItem({ ...newItem, purity: value });
//                   } else {
//                     toast.error("Purity cannot exceed 100%", 3000, "topRight");
//                   }
//                 }
//               }}
//             />
//           </div>
//           <div className="col-md-1">
//             <label className="form-label">Pure (g)</label>
//             <input
//               type="text"
//               className="form-control"
//               value={newItem.pure || "0.000"}
//               readOnly
//             />
//           </div>
//           <div className="col-md-1">
//             {editingItemId === null ? (
//               <button
//                 className="btn btn-success btn-sm mx-2 mt-4"
//                 onClick={handleAddItem}
//               >
//                 <i className="bi bi-plus"></i>
//               </button>
//             ) : (
//               <button
//                 className="btn btn-info btn-sm mx-2 mt-4"
//                 onClick={handleUpdateItem}
//               >
//                 <i className="bi bi-check"></i>
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Items List */}
//       <div className="container-fluid p-2">
//         <div className="row">
//           <div className="col-lg-9">
//             <div className="card card-body p-2">
//               <h6>Item List</h6>
//               <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
//                 <div className="table-container">
//                   <table className="table table-layout-fixed w-100">
//                     <thead className="bg-light">
//                       <tr>
//                         <th>S.No</th>
//                         <th>Item</th>
//                         <th>Category</th>
//                         <th>Type</th>
//                         <th>Quantity</th>
//                         <th>Weight(g)</th>
//                         <th>Purity (%)</th>
//                         <th>Pure(g)</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {formData.items.length > 0 ? (
//                         formData.items.map((item, index) => (
//                           <tr key={index}>
//                             <td>{index + 1}</td>
//                             <td>
//                               {item.item}
//                               {item.other_name ? ` (${item.other_name})` : ""}
//                             </td>
//                             <td>{item.category}</td>
//                             <td>{item.type || "-"}</td>
//                             <td>{item.quantity}</td>
//                             <td>{item.weight}g</td>
//                             <td>{item.purity}%</td>
//                             <td>{item.pure}g</td>
//                             <td>
//                               <button
//                                 className="btn btn-sm btn-light me-1"
//                                 onClick={() => handleEditItem(item.id)}
//                               >
//                                 <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                               </button>
//                               <button
//                                 className="btn btn-sm btn-light me-1"
//                                 onClick={() => handleRemoveItem(item.id)}
//                               >
//                                 <i className="fa-solid fa-trash text-danger fs-6"></i>
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="9" className="text-center">
//                             No items added yet
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Summary Section */}
//           <div className="col-lg-3">
//             <div className="card p-3">
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Total Pure (g)</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.total_pure || "0.000"}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Total Amount</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.total_amount || "0.000"}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Return Type</label>
//                 </div>
//                 <div className="col-md-6">
//                   <select
//                     className="form-select"
//                     value={formData.return_type || ""}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         return_type: e.target.value,
//                         pure: "",
//                         amount: "",
//                       })
//                     }
//                   >
//                     <option value="">Select Type</option>
//                     <option value="Pure">Pure</option>
//                     <option value="Amount">Amount</option>
//                   </select>
//                 </div>
//               </div>
//               {formData.return_type === "Pure" && (
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Pure (g)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="decimal"
//                       className="form-control"
//                       value={formData.pure || ""}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           const numericValue = parseFloat(value);
//                           const totalPure =
//                             parseFloat(formData.total_pure) || 0;
//                           if (
//                             value === "" ||
//                             (!isNaN(numericValue) &&
//                               numericValue >= 0 &&
//                               numericValue <= totalPure)
//                           ) {
//                             setFormData({ ...formData, pure: value });
//                             console.log("Pure value updated:", value);
//                           } else {
//                             toast.error(
//                               "Pure value must be between 0 and Total Pure",
//                               3000,
//                               "topRight"
//                             );
//                           }
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}
//               {formData.return_type === "Amount" && (
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       inputMode="decimal"
//                       className="form-control"
//                       value={formData.amount || ""}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           const numericValue = parseFloat(value);
//                           const totalPure =
//                             parseFloat(formData.total_pure) || 0;
//                           if (
//                             value === "" ||
//                             (!isNaN(numericValue) &&
//                               numericValue >= 0 &&
//                               numericValue <= totalPure)
//                           ) {
//                             setFormData({ ...formData, amount: value });
//                             console.log("Amount value updated:", value);
//                           } else {
//                             toast.error(
//                               "Amount must be between 0 and Total Pure",
//                               3000,
//                               "topRight"
//                             );
//                           }
//                         }
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Opening</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.opening || "0.000"}
//                     readOnly
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Current</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.current || "0.000"}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Closing</label>
//                 </div>
//                 <div className="col-md-6">
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.close || "0.000"}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="d-flex justify-content-between mt-2">
//                 <button
//                   className="btn btn-secondary btn-sm"
//                   onClick={() => navigate("/retailers")}
//                 >
//                   <i className="fa-solid fa-arrow-left"></i> Back
//                 </button>
//                 <button className="btn btn-danger btn-sm" onClick={handleClear}>
//                   <i className="bi bi-x-circle"></i> Clear
//                 </button>
//                 <button
//                   className="btn btn-primary btn-sm"
//                   onClick={() => setShowModal(true)}
//                   disabled={loading}
//                 >
//                   <i className="bi bi-printer"></i> Print
//                 </button>
//                 <button
//                   className="btn btn-success btn-sm"
//                   onClick={handleSave}
//                   disabled={loading}
//                 >
//                   <i className="bi bi-save"></i> Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Confirmation Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={() => setShowModal(false)}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the retailer bill?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={closeModal}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Print"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showModal && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default AddRetailer;



// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";

// function AddRetailer({ toggleSidebar }) {
//   const navigate = useNavigate();
//   const { retailerId } = useParams();
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);

//   // Form data state
//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: new Date().toISOString().split("T")[0],
//     supplier_id: "",
//     return_type: "",
//     enter_amount: "",
//     paid: "0",
//     pure: "0",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   // New item state
//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: 1,
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//     adjustment: "0.000",
//   });

//   const [adjustmentInput, setAdjustmentInput] = useState("");

//   const [todayRates, setTodayRates] = useState({
//     gold_pure_rate: 0,
//     silver_pure_rate: 0,
//     date: ""
//   });

//   // Fetch today's rates
//   const fetchTodayRates = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/current`);
//       if (response.data.status && response.data.data) {
//         const rates = response.data.data;
//         setTodayRates({
//           gold_pure_rate: parseFloat(rates.gold_pure_percentage) || 0,   // this is actually ₹/g pure
//           silver_pure_rate: parseFloat(rates.silver_pure_percentage) || 0,
//           date: rates.date
//         });
//       }
//     } catch (error) {
//       console.error("Failed to fetch today's rates", error);
//       // Optional: toast.warning("Using default rates", 3000, "topRight");
//     }
//   };

//   // Calculate pure and total_amount for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight) || 0;
//       const purity = parseFloat(newItem.purity) || 0;
//       const quantity = parseFloat(newItem.quantity) || 1;

//       if (purity > 100) {
//         toast.error("Purity cannot exceed 100%", 3000, "topRight");
//         setNewItem((prev) => ({ ...prev, purity: "" }));
//         return;
//       }

//       const singlePure = (weight * purity) / 100;
//       let calculatedPure = quantity * singlePure;

//       // Add manual adjustment if exists
//       const adjustment = parseFloat(newItem.adjustment) || 0;
//       calculatedPure += adjustment;

//       pure = calculatedPure.toFixed(3);
//       total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment, toast]);

//   // Calculate total_pure and total_amount from items
//   useEffect(() => {
//     const totalPure = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     setFormData((prev) => ({ ...prev, total_pure: totalPure }));
//   }, [formData.items]);

//   // Calculate current (opening + total_pure for Pure, opening + enter_amount for Amount)
//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     let current = "0.000";

//     if (formData.return_type === "Amount") {
//       const enter_amount = parseFloat(formData.enter_amount) || 0;
//       current = (opening + enter_amount).toFixed(3);
//     } else if (formData.return_type === "Pure") {
//       const totalPure = parseFloat(formData.total_pure) || 0;
//       current = (opening + totalPure).toFixed(3);
//     }

//     setFormData((prev) => ({ ...prev, current }));
//   }, [formData.total_pure, formData.opening, formData.enter_amount, formData.return_type]);

//   // Calculate closing (current - pure for Pure, current - paid for Amount)
//   useEffect(() => {
//     const totalPure = parseFloat(formData.total_pure) || 0;
//     const current = parseFloat(formData.current) || 0;
//     let close = current.toFixed(3);

//     if (formData.return_type === "Pure") {
//       const pure = parseFloat(formData.pure) || 0;
//       if (pure > totalPure) {
//         toast.error("Pure value cannot exceed Total Pure", 3000, "topRight");
//         setFormData((prev) => ({ ...prev, pure: "" }));
//         close = totalPure.toFixed(3);
//       } else {
//         close = (totalPure - pure).toFixed(3);
//       }
//     } else if (formData.return_type === "Amount") {
//       const paid = parseFloat(formData.paid) || 0;
//       if (paid > current) {
//         toast.error("Paid value cannot exceed Current", 3000, "topRight");
//         setFormData((prev) => ({ ...prev, paid: "" }));
//         close = current.toFixed(3);
//       } else {
//         close = (current - paid).toFixed(3);
//       }
//     }

//     setFormData((prev) => ({ ...prev, close }));
//   }, [formData.total_pure, formData.current, formData.pure, formData.paid, formData.return_type, toast]);
//   // Reset type when item is "Bar"
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...prev, type: "" }));
//     }
//   }, [newItem.item]);

//   // Fetch initial data
//   useEffect(() => {
//     toggleSidebar();
//     fetchInitialData();
//     fetchTodayRates();
//     if (retailerId) {
//       fetchRetailerData(retailerId);
//     }
//   }, [retailerId]);

//   useEffect(() => {
//     if (formData.return_type === "Amount" && formData.items.length > 0) {
//       let totalPureGold = 0;
//       let totalPureSilver = 0;

//       formData.items.forEach(item => {
//         const pure = parseFloat(item.pure) || 0;
//         if ((item.category === "Gold" || item.category === "Gold Coin")) {
//           totalPureGold += pure;
//         } else if ((item.category === "Silver" || item.category === "Silver Coin")) {
//           totalPureSilver += pure;
//         }
//       });

//       const amountFromGold = totalPureGold * todayRates.gold_pure_rate;
//       const amountFromSilver = totalPureSilver * todayRates.silver_pure_rate;
//       const totalAmount = (amountFromGold + amountFromSilver).toFixed(2);

//       setFormData(prev => ({
//         ...prev,
//         enter_amount: totalAmount
//       }));
//     }
//   }, [
//     formData.total_pure,
//     formData.items,
//     formData.return_type,
//     todayRates.gold_pure_rate,
//     todayRates.silver_pure_rate
//   ]);

//   const fetchInitialData = async () => {
//     try {
//       // Fetch retailer ID
//       const idResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
//       );
//       setGenerateNumber(idResponse.data.retailer_id || "");
//       setFormData((prev) => ({
//         ...prev,
//         retailer_id: idResponse.data.retailer_id || "",
//       }));

//       // Fetch supplier data
//       const supplierResponse = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(supplierResponse.data?.data || []);

//       // Fetch product types
//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);

//       // Set default opening to 0 until supplier and return_type are selected
//       setFormData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form data", 3000, "topRight");
//     }
//   };

//   const fetchRetailerData = async (id) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php?id=${id}`
//       );
//       const retailerData = response.data.data[0];

//       if (retailerId) {
//         setFormData({
//           retailer_id: retailerId.retailer_id,
//           retailer_date: retailerId.retailer_date,
//           supplier_id: retailerId.supplier_id,
//           return_type: retailerId.return_type,
//           enter_amount: retailerId.enter_amount || "",
//           paid: retailerId.paid || "",
//           pure: retailerId.pure || "",
//           opening: parseFloat(retailerId.opening).toFixed(3) || "0.000",
//           current: parseFloat(retailerId.current).toFixed(3) || "0.000",
//           close: parseFloat(retailerId.close).toFixed(3) || "0.000",
//           total_pure: parseFloat(retailerId.total_pure).toFixed(3) || "0.000",
//           items: retailerId.items.map((item, index) => ({
//             id: index + 1,
//             purchase_id: item.purchase_id,
//             item: item.item,
//             other_name: item.other_name || "",
//             category: item.category,
//             type: item.type || "",
//             quantity: parseFloat(item.quantity) || 0,
//             weight: parseFloat(item.weight) || 0,
//             purity: parseFloat(item.percentage) || 0,
//             pure: parseFloat(item.pure) || 0,
//             total_amount: parseFloat(item.total_amount) || 0,
//             adjustment: parseFloat(item.adjustment) || 0,
//           })),
//           supplier_details: {
//             supplier_id: retailerId.supplier.supplier_id,
//             name: retailerId.supplier.name,
//             mobile: retailerId.supplier.mobile,
//             address: retailerId.supplier.address,
//           },
//         });
//         setSelectedSupplier(retailerId.supplier);
//         setSearchTerm(
//           `${retailerId.supplier.supplier_id} - ${retailerId.supplier.name}`
//         );
//         setGenerateNumber(retailerId.purchase_id);
//       }
//     } catch (error) {
//       console.error("Error fetching Retailer data:", error);
//       toast.error("Failed to load Retailer data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle supplier selection and fetch supplier-specific opening balance based on return_type
//   const handleSelectSupplier = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: {
//         supplier_id: supplier.supplier_id,
//         name: supplier.name,
//         mobile: supplier.mobile,
//         address: supplier.address,
//       },
//     }));
//     setShowDropdown(false);

//     // Fetch supplier-specific opening balance based on return_type
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//       const supplierRetailers = response.data.data.filter(
//         (retailer) =>
//           retailer.supplier_id === supplier.supplier_id &&
//           retailer.return_type === formData.return_type
//       );
//       const totalOpening = supplierRetailers
//         .reduce((sum, retailer) => sum + parseFloat(retailer.close || 0), 0)
//         .toFixed(3);
//       setFormData((prev) => ({
//         ...prev,
//         opening: totalOpening || "0.000",
//       }));
//     } catch (error) {
//       console.error("Error fetching supplier retailers:", error);
//       setFormData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//       // toast.error("Failed to fetch supplier opening balance", 3000, "topRight");
//     }
//   };

//   // Update opening balance when return_type changes
//   useEffect(() => {
//     if (selectedSupplier && formData.return_type) {
//       const fetchOpeningBalance = async () => {
//         try {
//           const response = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//           const supplierRetailers = response.data.data.filter(
//             (retailer) =>
//               retailer.supplier_id === selectedSupplier.supplier_id &&
//               retailer.return_type === formData.return_type
//           );
//           const totalOpening = supplierRetailers
//             .reduce((sum, retailer) => sum + parseFloat(retailer.close || 0), 0)
//             .toFixed(3);
//           setFormData((prev) => ({
//             ...prev,
//             opening: totalOpening || "0.000",
//           }));
//         } catch (error) {
//           console.error("Error fetching supplier retailers for return_type:", error);
//           setFormData((prev) => ({
//             ...prev,
//             opening: "0.000",
//           }));
//           // toast.error("Failed to fetch opening balance", 3000, "topRight");
//         }
//       };
//       fetchOpeningBalance();
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         opening: "0.000",
//       }));
//     }
//   }, [formData.return_type, selectedSupplier, toast]);

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//       opening: "0.000",
//     }));
//   };

//   // Handle adding a new item
//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...formData.items,
//       {
//         id: formData.items.length + 1,
//         retailer_id: formData.retailer_id,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 0,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//         adjustment: parseFloat(newItem.adjustment) || 0,
//       },
//     ];

//     setFormData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   // Validate new item
//   const validateItem = () => {
//     if (!newItem.item) {
//       toast.error("Please select an item", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item !== "Bar" && !newItem.type) {
//       toast.error("Please select a type", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return false;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return false;
//     }
//     if (
//       !newItem.purity ||
//       parseFloat(newItem.purity) <= 0 ||
//       parseFloat(newItem.purity) > 100
//     ) {
//       toast.error("Please enter a valid purity (0-100%)", 3000, "topRight");
//       return false;
//     }
//     if (newItem.item === "Others" && !newItem.other_name) {
//       toast.error("Please enter a name for 'Others'", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Reset new item form
//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: 1,
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//       adjustment: "0.000",
//     });
//     setAdjustmentInput("");
//     setEditingItemId(null);
//   };

//   // Handle removing an item
//   const handleRemoveItem = (itemId) => {
//     const updatedItems = formData.items
//       .filter((item) => item.id !== itemId)
//       .map((item, index) => ({ ...item, id: index + 1 }));
//     setFormData((prev) => ({ ...prev, items: updatedItems }));
//   };

//   // Handle editing an item
//   const handleEditItem = (itemId) => {
//     const itemToEdit = formData.items.find((item) => item.id === itemId);
//     if (itemToEdit) {
//       setNewItem({
//         item: itemToEdit.item,
//         category: itemToEdit.category,
//         other_name: itemToEdit.other_name,
//         type: itemToEdit.type,
//         quantity: itemToEdit.quantity.toString(),
//         weight: itemToEdit.weight.toString(),
//         purity: itemToEdit.purity.toString(),
//         pure: itemToEdit.pure.toFixed(3),
//         total_amount: itemToEdit.total_amount.toFixed(3),
//         adjustment: (itemToEdit.adjustment || 0).toFixed(3),
//       });
//       setAdjustmentInput("");
//       setEditingItemId(itemId);
//     }
//   };

//   // Handle updating an item
//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updatedItems = formData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//           ...item,
//           item: newItem.item,
//           retailer_id: formData.retailer_id,
//           category: newItem.category,
//           other_name: newItem.other_name,
//           type: newItem.type,
//           quantity: parseFloat(newItem.quantity) || 0,
//           weight: parseFloat(newItem.weight) || 0,
//           purity: parseFloat(newItem.purity) || 0,
//           pure: parseFloat(newItem.pure) || 0,
//           total_amount: parseFloat(newItem.total_amount) || 0,
//           adjustment: parseFloat(newItem.adjustment) || 0,
//         }
//         : item
//     );

//     setFormData((prev) => ({ ...prev, items: updatedItems }));
//     resetNewItem();
//   };

//   // Validate form before save or print
//   const validateForm = () => {
//     if (!formData.retailer_id) {
//       toast.error("Retailer ID is required", 3000, "topRight");
//       return false;
//     }
//     if (!formData.retailer_date) {
//       toast.error("Retailer date is required", 3000, "topRight");
//       return false;
//     }
//     if (!formData.supplier_id) {
//       toast.error("Please select a supplier", 3000, "topRight");
//       return false;
//     }
//     if (formData.items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (!formData.return_type) {
//       toast.error("Please select the return type", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Pure" &&
//       (!formData.pure || parseFloat(formData.pure) < 0)
//     ) {
//       toast.error("Please enter a valid pure value", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Amount" &&
//       (!formData.enter_amount || parseFloat(formData.enter_amount) <= 0)
//     ) {
//       toast.error("Please enter a valid amount", 3000, "topRight");
//       return false;
//     }
//     if (
//       formData.return_type === "Amount" &&
//       (!formData.amount || parseFloat(formData.amount) < 0)
//     ) {
//       toast.error("Please enter a valid paid amount", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Prepare payload for API
//   const preparePayload = () => {
//     let payload = {
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       supplier_id: formData.supplier_id,
//       return_type: formData.return_type,
//       enter_amount: parseFloat(formData.enter_amount) || 0,
//       paid: parseFloat(formData.amount) || 0,
//       pure: parseFloat(formData.pure) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       total_amount: parseFloat(formData.total_amount) || 0,
//       items: formData.items.map((item) => ({
//         category: item.category,
//         quantity: parseFloat(item.quantity) || 0,
//         item: item.item,
//         weight: parseFloat(item.weight) || 0,
//         type: item.type,
//         other_name: item.other_name || "",
//         percentage: parseFloat(item.purity) || 0,
//         pure: parseFloat(item.pure) || 0,
//         total_amount: parseFloat(item.total_amount) || 0,
//         adjustment: parseFloat((item.adjustment || "0").toString()) || 0,
//         retailer_id: formData.retailer_id,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.enter_amount = 0;
//       payload.paid = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     } else {
//       payload.enter_amount = 0;
//       payload.pure = 0;
//       payload.paid = 0;
//     }

//     return payload;
//   };

//   // Handle saving the retailer
//   const handleSave = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const response = await axios.post(
//         `${ApiUrl}/Api/retailer_details.php`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Retailer saved successfully!", 3000, "topRight");
//         handleClear();
//         await fetchInitialData();
//         navigate("/retailers");
//       } else {
//         toast.error(
//           response.data.message || "Failed to save retailer",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       toast.error(
//         error.response?.data?.message || "Failed to save retailer",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle printing the retailer
//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const response = await axios.post(
//         `${ApiUrl}/Api/retailer_details.php`,
//         payload
//       );

//       if (response.status === 200 || response.status === 201) {
//         toast.success("Retailer saved successfully!", 3000, "topRight");
//         setShowModal(true);
//       } else {
//         toast.error(
//           response.data.message || "Failed to save retailer for print",
//           3000,
//           "topRight"
//         );
//       }
//     } catch (error) {
//       console.error("Print error:", error);
//       toast.error(
//         error.response?.data?.message || "Failed to save and print retailer",
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Clear form
//   const handleClear = () => {
//     setFormData({
//       retailer_id: generateNumber,
//       retailer_date: new Date().toISOString().split("T")[0],
//       supplier_id: "",
//       return_type: "",
//       enter_amount: "",
//       paid: "",
//       pure: "",
//       opening: "0.000",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       total_amount: "0.000",
//       items: [],
//       supplier_details: {
//         supplier_id: "",
//         name: null,
//         mobile: null,
//         address: null,
//       },
//     });
//     resetNewItem();
//     clearSupplier();
//     setSearchTerm("");
//   };

//   // Modal controls
//   const closeModal = () => {
//     setShowModal(false);
//     handleClear();
//     navigate(`/retailer-bill/${formData.retailer_id}`);
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}
//       <div className="container-fluid py-2">
//         {/* Form Header */}
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Retailer ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={generateNumber}
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={formData.retailer_date}
//                     onChange={(e) =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         retailer_date: e.target.value,
//                       }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button
//                         className="btn btn-outline-secondary h-75"
//                         type="button"
//                         onClick={clearSupplier}
//                       >
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(
//                           (supplier) =>
//                             supplier.supplier_id
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase()) ||
//                             supplier.name
//                               .toLowerCase()
//                               .includes(searchTerm.toLowerCase())
//                         )
//                         .map((supplier) => (
//                           <button
//                             key={supplier.supplier_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectSupplier(supplier)}
//                             type="button"
//                           >
//                             {supplier.supplier_id} - {supplier.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Supplier Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       formData.supplier_details?.name ||
//                       selectedSupplier?.name ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       formData.supplier_details?.mobile ||
//                       selectedSupplier?.mobile ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     value={
//                       formData.supplier_details?.address ||
//                       selectedSupplier?.address ||
//                       ""
//                     }
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Item Entry Form */}
//         <div className="card p-2 mt-1">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label className="form-label">Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select Item</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label className="form-label">Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Others Name"
//                   value={newItem.other_name}
//                   onChange={(e) =>
//                     setNewItem({ ...newItem, other_name: e.target.value })
//                   }
//                 />
//               </div>
//             )}

//             <div className="col-md-2">
//               <label className="form-label">Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, category: e.target.value })
//                 }
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>
//             <div className="col-md-2">
//               <label className="form-label">Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, type: e.target.value })
//                 }
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select Type</option>
//                 {Array.isArray(productTypes) &&
//                   productTypes.map((item) => (
//                     <option key={item._id} value={item.type}>
//                       {item.type}
//                     </option>
//                   ))}
//               </select>
//             </div>
//             {/* <div className="col-md-1">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 pattern="[0-9]*"
//                 maxLength="5"
//                 className="form-control"
//                 placeholder="Quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     setNewItem({ ...newItem, quantity: value });
//                   }
//                 }}
//               />
//             </div> */}
//             <div className="col-md-1">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     setNewItem({ ...newItem, weight: value });
//                   }
//                 }}
//               />
//             </div>

//             {/* Adjustment Input with + / - and tiny × */}
//             <div className="col-md-1">
//               <label className="form-label">Adjustment</label>
//               <div className="input-group">
//                 <button
//                   className="btn btn-outline-danger btn-sm rounded"
//                   type="button"
//                   style={{ height: "30px", width: "10px" }}
//                   disabled={parseFloat(newItem.adjustment || 0) <= -9999} // optional limit
//                   onClick={() => {
//                     const val = parseFloat(adjustmentInput) || 0;
//                     if (val > 0) {
//                       setNewItem(prev => ({
//                         ...prev,
//                         adjustment: (parseFloat(prev.adjustment || 0) - val).toFixed(3)
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i class="fa-solid fa-minus" style={{ position: "absolute", left: "3px", top: "8px", fontSize: "12px" }}></i>
//                 </button>

//                 <div className="position-relative">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm text-center"
//                     placeholder="0.00"
//                     style={{ width: "53px" }}
//                     value={adjustmentInput}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d*\.?\d*$/.test(value)) {
//                         setAdjustmentInput(value);
//                       }
//                     }}
//                     onKeyPress={(e) => {
//                       if (e.key === "Enter") {
//                         const val = parseFloat(adjustmentInput) || 0;
//                         if (val > 0) {
//                           const currentAdj = parseFloat(newItem.adjustment || 0);
//                           setNewItem(prev => ({
//                             ...prev,
//                             adjustment: (currentAdj + val).toFixed(3)
//                           }));
//                           setAdjustmentInput("");
//                         }
//                       }
//                     }}
//                   />

//                   {/* Tiny × button - only shows when adjustment exists */}
//                   {parseFloat(newItem.adjustment || 0) !== 0 && (
//                     <button
//                       type="button"
//                       className="position-absolute end-0 top-0 border-0 bg-transparent"
//                       style={{
//                         fontSize: "0.95rem",
//                         fontWeight: "bold",
//                         color: "#dc3545",           // Bootstrap danger red
//                         zIndex: 8,
//                         lineHeight: 1,
//                         position: "absolute",
//                         right: "10px",
//                         padding: 0,
//                         width: "20px",
//                         height: "20px",
//                       }}
//                       onClick={() => {
//                         setNewItem(prev => ({ ...prev, adjustment: "0.000" }));
//                         setAdjustmentInput("");
//                       }}
//                       aria-label="Clear adjustment"
//                     >
//                       ×
//                     </button>
//                   )}
//                 </div>

//                 <button
//                   className="btn btn-outline-success btn-sm rounded"
//                   type="button"
//                   style={{ height: "30px", width: "10px" }}
//                   onClick={() => {
//                     const val = parseFloat(adjustmentInput) || 0;
//                     if (val > 0) {
//                       setNewItem(prev => ({
//                         ...prev,
//                         adjustment: (parseFloat(prev.adjustment || 0) + val).toFixed(3)
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 ><i class="fa-solid fa-plus" style={{ position: "absolute", left: "3px", top: "7px" }}></i>
//                 </button>
//               </div>
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Purity (%)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Purity"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
//                     const numericValue = parseFloat(value);
//                     if (
//                       value === "" ||
//                       (!isNaN(numericValue) && numericValue <= 100)
//                     ) {
//                       setNewItem({ ...newItem, purity: value });
//                     } else {
//                       toast.error("Purity cannot exceed 100%", 3000, "topRight");
//                     }
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Pure (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.pure || "0.000"}
//                 readOnly
//               />
//             </div>
//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm mx-2 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm mx-2 mt-4"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Items List */}
//         <div className="container-fluid p-2">
//           <div className="row">
//             <div className="col-lg-9">
//               <div className="card card-body p-2">
//                 <h6>Item List</h6>
//                 <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
//                   <div className="table-container">
//                     <table className="table table-layout-fixed w-100">
//                       <thead className="bg-light">
//                         <tr>
//                           <th>S.No</th>
//                           <th>Item</th>
//                           <th>Category</th>
//                           <th>Type</th>
//                           {/* <th>Quantity</th> */}
//                           <th>Weight(g)</th>
//                           <th>Purity (%)</th>
//                           <th>Pure(g)</th>
//                           <th>Adjustment</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {formData.items.length > 0 ? (
//                           formData.items.map((item, index) => (
//                             <tr key={item.id || index}>
//                               <td>{index + 1}</td>
//                               <td>
//                                 {item.item}
//                                 {item.other_name ? ` (${item.other_name})` : ""}
//                               </td>
//                               <td>{item.category}</td>
//                               <td>{item.type || "-"}</td>
//                               <td>{parseFloat(item.weight).toFixed(3)}g</td>
//                               <td>{parseFloat(item.purity).toFixed(2)}%</td>
//                               <td>{parseFloat(item.pure).toFixed(3)}g</td>
//                               <td className="text-end">
//                                 <span className={`fw-bold ${parseFloat(item.adjustment) > 0
//                                   ? "text-success"
//                                   : parseFloat(item.adjustment) < 0
//                                     ? "text-danger"
//                                     : "text-muted"
//                                   }`}>
//                                   {parseFloat(item.adjustment) > 0 ? "+" : ""}
//                                   {parseFloat(item.adjustment || 0).toFixed(3)}g
//                                 </span>
//                               </td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-light me-1"
//                                   onClick={() => handleEditItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-light"
//                                   onClick={() => handleRemoveItem(item.id)}
//                                 >
//                                   <i className="fa-solid fa-trash text-danger fs-6"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="10" className="text-center">No items added yet</td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Summary Section */}
//             <div className="col-lg-3">
//               <div className="card p-3">
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Total Pure (g)</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.total_pure || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 {/* <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Total Amount</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.total_amount || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div> */}

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Return Type</label>
//                   </div>
//                   <div className="col-md-6">
//                     <select
//                       className="form-select"
//                       value={formData.return_type || ""}
//                       onChange={(e) =>
//                         setFormData({
//                           ...formData,
//                           return_type: e.target.value,
//                           enter_amount: "",
//                           amount: "",
//                           pure: "",
//                         })
//                       }
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Pure">Pure</option>
//                       <option value="Amount">Amount</option>
//                     </select>
//                   </div>
//                 </div>

//                 {formData.return_type === "Pure" && (
//                   <div className="row mb-3">
//                     <div className="col-md-3">
//                       <label className="form-label">Pure%</label>
//                     </div>
//                     <div className="col-md-3">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={""}
//                       />
//                     </div>
//                     <div className="col-md-3">
//                       <label className="form-label">Pure(g)</label>
//                     </div>
//                     <div className="col-md-3">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={formData.pure || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             const numericValue = parseFloat(value);
//                             const totalPure = parseFloat(formData.total_pure) || 0;
//                             if (
//                               value === "" ||
//                               (!isNaN(numericValue) && numericValue >= 0 && numericValue <= totalPure)
//                             ) {
//                               setFormData({ ...formData, pure: value });
//                             } else {
//                               toast.error(
//                                 "Pure value must be between 0 and Total Pure",
//                                 3000,
//                                 "topRight"
//                               );
//                             }
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {formData.return_type === "Amount" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">
//                         Enter Amount
//                       </label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={formData.enter_amount || "0.00"}
//                         readOnly // Make it read-only so user knows it's calculated
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {formData.return_type === "Amount" && (
//                   <div className="row mb-3">
//                     <div className="col-md-6">
//                       <label className="form-label">Paid</label>
//                     </div>
//                     <div className="col-md-6">
//                       <input
//                         type="text"
//                         inputMode="decimal"
//                         className="form-control"
//                         value={formData.paid || ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             const numericValue = parseFloat(value);
//                             const current = parseFloat(formData.current) || 0;
//                             if (
//                               value === "" ||
//                               (!isNaN(numericValue) && numericValue >= 0 && numericValue <= current)
//                             ) {
//                               setFormData({ ...formData, paid: value });
//                             } else {
//                               toast.error(
//                                 "Paid value cannot exceed Current",
//                                 3000,
//                                 "topRight"
//                               );
//                             }
//                           }
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Opening</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.opening || "0.000"}
//                       readOnly
//                       style={{ opacity: 0.6, backgroundColor: "#f0f0f0" }}
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Current</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.current || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mb-3">
//                   <div className="col-md-6">
//                     <label className="form-label">Closing</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.close || "0.000"}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="d-flex justify-content-between mt-2">
//                   <button
//                     className="btn btn-secondary btn-sm"
//                     onClick={() => navigate("/retailers")}
//                   >
//                     <i className="fa-solid fa-arrow-left"></i> Back
//                   </button>
//                   <button
//                     className="btn btn-danger btn-sm"
//                     onClick={handleClear}
//                   >
//                     <i className="bi bi-x-circle"></i> Clear
//                   </button>
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={handlePrint}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-printer"></i> Print
//                   </button>
//                   <button
//                     className="btn btn-success btn-sm"
//                     onClick={handleSave}
//                     disabled={loading}
//                   >
//                     <i className="bi bi-save"></i> Save
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Confirmation Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={() => setShowModal(false)}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the retailer bill?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={() => navigate("/retailers")}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={closeModal}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Print"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showModal && <div className="modal-backdrop fade show"></div>}
//     </>
//   );
// }

// export default AddRetailer;


// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";

// function AddRetailer({ toggleSidebar }) {
//   const navigate = useNavigate();
//   const { retailerId } = useParams();
//   const toast = useToast();

//   const [loading, setLoading] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const [userdata, setUserdata] = useState([]);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [staffList, setStaffList] = useState([]);
//   const [isManagerLocked, setIsManagerLocked] = useState(false);
//   const [isStaffLocked, setIsStaffLocked] = useState(false);
//   // New item state
//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: 1,
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//     adjustment: "0.000",
//   });

//   const [adjustmentInput, setAdjustmentInput] = useState("");

//   const [todayRates, setTodayRates] = useState({
//     gold_pure_rate: 0,
//     silver_pure_rate: 0,
//     date: "",
//   });

//   const [returnPureCalculated, setReturnPureCalculated] = useState("0.000");

//   // Form data
//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: new Date().toISOString().split("T")[0],
//     supplier_id: "",
//     return_type: "",
//     enter_amount: "",
//     paid: "0",
//     pure: "0",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     manager: "",
//     manager_name: "",
//     adjustment: "0.000",
//     staff: "",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   // Fetch today's rates
//   const fetchTodayRates = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/current`);
//       if (response.data.status && response.data.data) {
//         const rates = response.data.data;
//         setTodayRates({
//           gold_pure_rate: parseFloat(rates.gold_pure_percentage) || 0,
//           silver_pure_rate: parseFloat(rates.silver_pure_percentage) || 0,
//           date: rates.date,
//         });
//       }
//     } catch (error) {
//       console.error("Failed to fetch today's rates", error);
//     }
//   };

//   // Calculate pure for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight) || 0;
//       const purity = parseFloat(newItem.purity) || 0;
//       const quantity = parseFloat(newItem.quantity) || 1;

//       if (purity > 100) {
//         toast.error("Purity cannot exceed 100%", 3000, "topRight");
//         setNewItem((prev) => ({ ...prev, purity: "" }));
//         return;
//       }

//       const singlePure = (weight * purity) / 100;
//       let calculatedPure = quantity * singlePure;

//       const adjustment = parseFloat(newItem.adjustment) || 0;
//       calculatedPure += adjustment;

//       pure = calculatedPure.toFixed(3);
//       total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment, toast]);

//   // Total pure from all items
//   useEffect(() => {
//     const totalPure = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);
//     setFormData((prev) => ({ ...prev, total_pure: totalPure }));
//   }, [formData.items]);

//   // MAIN CALCULATION – Current, Return Pure, Closing
//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     const totalPure = parseFloat(formData.total_pure) || 0;

//     // Current = Opening + Total Pure
//     const current = (opening + totalPure).toFixed(3);

//     let returnPureGrams = 0;

//     if (formData.return_type === "Pure") {
//       returnPureGrams = parseFloat(formData.pure || 0);
//     } else if (formData.return_type === "Amount") {
//       const paid = parseFloat(formData.paid) || 0;
//       const hasGold = formData.items.some((i) => (i.category === "Gold" || i.category === "Gold Coin"));
//       const hasSilver = formData.items.some((i) => (i.category === "Silver" || i.category === "Silver Coin"));

//       const rate =
//         hasGold && !hasSilver
//           ? todayRates.gold_pure_rate
//           : hasSilver && !hasGold
//             ? todayRates.silver_pure_rate
//             : todayRates.gold_pure_rate || 1;

//       returnPureGrams = rate > 0 ? paid / rate : 0;
//       setReturnPureCalculated(returnPureGrams.toFixed(3));
//     }

//     const balance = (parseFloat(current) - returnPureGrams).toFixed(3);

//     setFormData((prev) => ({
//       ...prev,
//       current,
//       close: balance,
//       ...(formData.return_type === "Amount" && { pure: "0" }),
//     }));
//   }, [
//     formData.opening,
//     formData.total_pure,
//     formData.return_type,
//     formData.pure,
//     formData.paid,
//     formData.items,
//     todayRates.gold_pure_rate,
//     todayRates.silver_pure_rate,
//   ]);

//   // Amount mode: calculate enter_amount from total pure
//   useEffect(() => {
//     if (formData.return_type === "Amount" && formData.items.length > 0) {
//       let goldPure = 0;
//       let silverPure = 0;

//       formData.items.forEach((item) => {
//         const p = parseFloat(item.pure) || 0;
//         if ((item.category === "Gold" || item.category === "Gold Coin")) goldPure += p;
//         else if ((item.category === "Silver" || item.category === "Silver Coin")) silverPure += p;
//       });

//       const amount =
//         goldPure * todayRates.gold_pure_rate +
//         silverPure * todayRates.silver_pure_rate;

//       setFormData((prev) => ({
//         ...prev,
//         enter_amount: amount.toFixed(2),
//       }));
//     }
//   }, [
//     formData.items,
//     formData.return_type,
//     formData.total_pure,
//     todayRates.gold_pure_rate,
//     todayRates.silver_pure_rate,
//   ]);

//   // Reset type when item is Bar
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem((prev) => ({ ...prev, type: "" }));
//     }
//   }, [newItem.item]);

//   // Initial load
//   useEffect(() => {
//     toggleSidebar();
//     fetchInitialData();
//     fetchTodayRates();
//     fetchUserData();           // ← NEW
//     fetchLoggedInUser();
//     if (retailerId) {
//       fetchRetailerData(retailerId);
//     }
//   }, [retailerId]);

//   const fetchInitialData = async () => {
//     try {
//       const idResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
//       );
//       setGenerateNumber(idResponse.data.retailer_id || "");
//       if (!retailerId) {
//         setFormData((prev) => ({
//           ...prev,
//           retailer_id: idResponse.data.retailer_id || "",
//         }));
//       }

//       const supplierResponse = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(supplierResponse.data?.data || []);

//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form", 3000, "topRight");
//     }
//   };

//   const fetchRetailerData = async (id) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php?id=${id}`
//       );
//       const data = response.data.data[0];

//       if (data) {
//         setFormData({
//           retailer_id: data.retailer_id,
//           retailer_date: data.retailer_date,
//           supplier_id: data.supplier_id,
//           return_type: data.return_type || "",
//           enter_amount: data.enter_amount || "",
//           paid: data.paid || "0",
//           pure: data.pure || "0",
//           opening: parseFloat(data.opening || 0).toFixed(3),
//           current: parseFloat(data.current || 0).toFixed(3),
//           close: parseFloat(data.close || 0).toFixed(3),
//           total_pure: parseFloat(data.total_pure || 0).toFixed(3),
//           items: data.items.map((item, index) => ({
//             id: index + 1,
//             item: item.item,
//             other_name: item.other_name || "",
//             category: item.category,
//             type: item.type || "",
//             quantity: parseFloat(item.quantity) || 0,
//             weight: parseFloat(item.weight) || 0,
//             purity: parseFloat(item.percentage) || 0,
//             pure: parseFloat(item.pure) || 0,
//             total_amount: parseFloat(item.total_amount) || 0,
//             adjustment: parseFloat(item.adjustment) || 0,
//           })),
//           supplier_details: { ...data.supplier },
//         });

//         setSelectedSupplier(data.supplier);
//         setSearchTerm(
//           `${data.supplier.supplier_id} - ${data.supplier.name}`
//         );
//         setGenerateNumber(data.retailer_id);
//       }
//     } catch (error) {
//       console.error("Error loading retailer:", error);
//       toast.error("Failed to load retailer data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Opening balance – same logic as Purchase (latest closing of same metal + return_type)
//   const fetchOpeningBalance = async (supplierId) => {
//     if (!supplierId || !formData.return_type) {
//       setFormData((prev) => ({ ...prev, opening: "0.000" }));
//       return;
//     }

//     try {
//       const res = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//       const all = res.data?.data || [];

//       const relevant = all
//         .filter(
//           (r) =>
//             r.supplier_id === supplierId && r.return_type === formData.return_type
//         )
//         .sort((a, b) => new Date(b.retailer_date) - new Date(a.retailer_date));

//       let opening = "0.000";
//       if (relevant.length > 0) {
//         const latest = relevant[0];

//         const hasGold = latest.items?.some((i) => (i.category === "Gold" || i.category === "Gold Coin"));
//         const hasSilver = latest.items?.some((i) => (i.category === "Silver" || i.category === "Silver Coin"));
//         const latestGoldOnly = hasGold && !hasSilver;
//         const latestSilverOnly = hasSilver && !hasGold;

//         const curGold = formData.items.some((i) => (i.category === "Gold" || i.category === "Gold Coin"));
//         const curSilver = formData.items.some((i) => (i.category === "Silver" || i.category === "Silver Coin"));
//         const curGoldOnly = curGold && !curSilver;
//         const curSilverOnly = curSilver && !curGold;

//         if (
//           (curGoldOnly && latestGoldOnly) ||
//           (curSilverOnly && latestSilverOnly) ||
//           (!curGoldOnly && !curSilverOnly)
//         ) {
//           opening = parseFloat(latest.close || 0).toFixed(3);
//         }
//       }

//       setFormData((prev) => ({ ...prev, opening }));
//     } catch (err) {
//       setFormData((prev) => ({ ...prev, opening: "0.000" }));
//     }
//   };

//   useEffect(() => {
//     if (selectedSupplier?.supplier_id) {
//       fetchOpeningBalance(selectedSupplier.supplier_id);
//     }
//   }, [selectedSupplier, formData.return_type, formData.items]);

//   const handleSelectSupplier = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: { ...supplier },
//       opening: "0.000",
//     }));
//     setShowDropdown(false);
//     await fetchOpeningBalance(supplier.supplier_id);
//   };

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: { supplier_id: "", name: null, mobile: null, address: null },
//       opening: "0.000",
//     }));
//   };

//   // Item functions – identical to Purchase
//   const validateItem = () => {
//     if (!newItem.item) return toast.error("Select item", 3000, "topRight"), false;
//     if (!newItem.category) return toast.error("Select category", 3000, "topRight"), false;
//     if (newItem.item !== "Bar" && !newItem.type)
//       return toast.error("Select type", 3000, "topRight"), false;
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0)
//       return toast.error("Valid quantity required", 3000, "topRight"), false;
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0)
//       return toast.error("Valid weight required", 3000, "topRight"), false;
//     if (!newItem.purity || parseFloat(newItem.purity) <= 0 || parseFloat(newItem.purity) > 100)
//       return toast.error("Valid purity (0-100%)", 3000, "topRight"), false;
//     if (newItem.item === "Others" && !newItem.other_name)
//       return toast.error("Enter name for Others", 3000, "topRight"), false;
//     return true;
//   };

//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...formData.items,
//       {
//         id: formData.items.length + 1,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 0,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//         adjustment: parseFloat(newItem.adjustment) || 0,
//       },
//     ];

//     setFormData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updated = formData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//           ...item,
//           item: newItem.item,
//           other_name: newItem.other_name,
//           category: newItem.category,
//           type: newItem.type,
//           quantity: parseFloat(newItem.quantity) || 0,
//           weight: parseFloat(newItem.weight) || 0,
//           purity: parseFloat(newItem.purity) || 0,
//           pure: parseFloat(newItem.pure) || 0,
//           total_amount: parseFloat(newItem.total_amount) || 0,
//           adjustment: parseFloat(newItem.adjustment) || 0,
//         }
//         : item
//     );

//     setFormData((prev) => ({ ...prev, items: updated }));
//     resetNewItem();
//   };

//   const handleEditItem = (id) => {
//     const item = formData.items.find((i) => i.id === id);
//     if (item) {
//       setNewItem({
//         item: item.item,
//         category: item.category,
//         other_name: item.other_name || "",
//         type: item.type || "",
//         quantity: item.quantity.toString(),
//         weight: item.weight.toString(),
//         purity: item.purity.toString(),
//         pure: item.pure.toFixed(3),
//         total_amount: item.total_amount.toFixed(3),
//         adjustment: (item.adjustment || 0).toFixed(3),
//       });
//       setAdjustmentInput("");
//       setEditingItemId(id);
//     }
//   };

//   const handleRemoveItem = (id) => {
//     const filtered = formData.items
//       .filter((i) => i.id !== id)
//       .map((i, idx) => ({ ...i, id: idx + 1 }));
//     setFormData((prev) => ({ ...prev, items: filtered }));
//   };

//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: 1,
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//       adjustment: "0.000",
//     });
//     setAdjustmentInput("");
//     setEditingItemId(null);
//   };

//   const validateForm = () => {
//     if (!formData.retailer_id) return toast.error("Retailer ID required", 3000, "topRight"), false;
//     if (!formData.retailer_date) return toast.error("Date required", 3000, "topRight"), false;
//     if (!formData.supplier_id) return toast.error("Select supplier", 3000, "topRight"), false;
//     if (formData.items.length === 0) return toast.error("Add at least one item", 3000, "topRight"), false;
//     if (!formData.return_type) return toast.error("Select return type", 3000, "topRight"), false;
//     if (formData.return_type === "Pure" && parseFloat(formData.pure) < 0)
//       return toast.error("Enter valid pure return", 3000, "topRight"), false;
//     if (formData.return_type === "Amount" && (!formData.paid || parseFloat(formData.paid) <= 0))
//       return toast.error("Enter valid paid amount", 3000, "topRight"), false;
//     return true;
//   };

//   const preparePayload = () => {
//     const payload = {
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       supplier_id: formData.supplier_id,
//       return_type: formData.return_type,
//       enter_amount: parseFloat(formData.enter_amount) || 0,
//       paid: parseFloat(formData.paid) || 0,
//       pure: parseFloat(formData.pure) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       manager: formData.manager || "",
//       staff: formData.staff || "",
//       items: formData.items.map((i) => ({
//         category: i.category,
//         quantity: i.quantity,
//         item: i.item,
//         weight: i.weight,
//         type: i.type || "",
//         other_name: i.other_name || "",
//         percentage: i.purity,
//         pure: i.pure,
//         total_amount: i.total_amount,
//         adjustment: i.adjustment,
//         retailer_id: formData.retailer_id,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.enter_amount = 0;
//       payload.paid = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     }

//     return payload;
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

//       if (res.status === 200 || res.status === 201) {
//         toast.success("Retailer saved!", 3000, "topRight");
//         handleClear();
//         await fetchInitialData();
//         navigate("/retailers");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Save failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

//       if (res.status === 200 || res.status === 201) {
//         toast.success("Saved for print", 3000, "topRight");
//         setShowModal(true);
//       }
//     } catch (err) {
//       toast.error("Print failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClear = () => {
//     setFormData({
//       retailer_id: generateNumber,
//       retailer_date: new Date().toISOString().split("T")[0],
//       supplier_id: "",
//       return_type: "",
//       enter_amount: "",
//       paid: "0",
//       pure: "0",
//       opening: "0.000",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       items: [],
//       supplier_details: { supplier_id: "", name: null, mobile: null, address: null },
//     });
//     resetNewItem();
//     clearSupplier();
//     setSearchTerm("");
//     setReturnPureCalculated("0.000");
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     handleClear();
//     navigate(`/retailer-bill/${formData.retailer_id}`);
//   };

//   const fetchLoggedInUser = () => {
//     try {
//       const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//       if (userInfo && userInfo.user_id) {
//         setLoggedInUser(userInfo);
//       }
//     } catch (error) {
//       console.error("Error reading logged-in user:", error);
//     }
//   };

//   // Fetch all users (for manager/staff dropdowns)
//   const fetchUserData = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}/Api/user.php`);
//       const users = Array.isArray(res.data.data) ? res.data.data : [];
//       setUserdata(users);
//     } catch (err) {
//       console.error("Failed to fetch users", err);
//       toast.error("Failed to load staff data", 3000, 'topRight');
//     }
//   };

//   // Auto-lock Manager & Staff based on logged-in user role
//   useEffect(() => {
//     if (!loggedInUser || userdata.length === 0) return;

//     const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
//     if (!currentUser) return;

//     if (currentUser.role === "Manager" || currentUser.role === "manager") {
//       setSelectedManager(currentUser.id.toString());
//       setIsManagerLocked(true);

//       // Load staff under this manager
//       const staff = userdata.filter(
//         u => u.manager_id === currentUser.user_id && (u.role === "Employee" || u.role === "employee")
//       );
//       setStaffList(staff);

//       // Optional: pre-fill in form if you store manager/staff in formData
//       setFormData(prev => ({
//         ...prev,
//         manager: currentUser.user_id,
//         manager_name: currentUser.name,
//       }));
//     }
//     else if (currentUser.role === "Employee" || currentUser.role === "employee") {
//       setSelectedStaff(currentUser.name);
//       setIsStaffLocked(true);

//       const manager = userdata.find(
//         u => u.user_id === currentUser.manager_id && (u.role === "Manager" || u.role === "manager")
//       );

//       if (manager) {
//         setSelectedManager(manager.id.toString());
//         setIsManagerLocked(true);

//         const staffUnderManager = userdata.filter(
//           u => u.manager_id === manager.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staffUnderManager);

//         setFormData(prev => ({
//           ...prev,
//           manager: manager.user_id,
//           manager_name: manager.name,
//           staff: currentUser.name,
//         }));
//       }
//     }
//     // Admin → do nothing (free choice)
//   }, [loggedInUser, userdata]);

//   // Handle Manager Change
//   const handleManagerChange = (e) => {
//     if (isManagerLocked) return;
//     const managerId = e.target.value;
//     setSelectedManager(managerId);
//     setSelectedStaff("");
//     setStaffList([]);

//     if (managerId) {
//       const managerObj = userdata.find(u => u.id === parseInt(managerId));
//       if (managerObj) {
//         const staff = userdata.filter(
//           u => u.manager_id === managerObj.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staff);

//         setFormData(prev => ({
//           ...prev,
//           manager: managerObj.user_id,
//           manager_name: managerObj.name,
//         }));
//       }
//     } else {
//       setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
//     }
//   };

//   // Handle Staff Change
//   const handleStaffChange = (e) => {
//     if (isStaffLocked) return;
//     const staffName = e.target.value;
//     setSelectedStaff(staffName);
//     setFormData(prev => ({ ...prev, staff: staffName }));
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid py-2">
//         {/* Header */}
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Retailer ID</label>
//                   <input type="text" className="form-control" value={generateNumber} readOnly />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={formData.retailer_date}
//                     onChange={(e) =>
//                       setFormData((p) => ({ ...p, retailer_date: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Supplier Section */}
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button className="btn btn-outline-secondary" onClick={clearSupplier}>
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(
//                           (s) =>
//                             s.supplier_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                             s.name.toLowerCase().includes(searchTerm.toLowerCase())
//                         )
//                         .map((s) => (
//                           <button
//                             key={s.supplier_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectSupplier(s)}
//                             type="button"
//                           >
//                             {s.supplier_id} - {s.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.supplier_details?.name || ""}
//                     disabled
//                     style={{ backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.supplier_details?.mobile || ""}
//                     disabled
//                     style={{ backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.supplier_details?.address || ""}
//                     disabled
//                     style={{ backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row mt-3">
//           <div className="col-md-3">
//             <label className="form-label">
//               Manager <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedManager}
//               onChange={handleManagerChange}
//               disabled={isManagerLocked}
//             >
//               <option value="">Select Manager</option>
//               {userdata
//                 .filter(u => u.role === "Manager" || u.role === "manager")
//                 .map(manager => (
//                   <option key={manager.id} value={manager.id}>
//                     {manager.name}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">
//               Staff <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedStaff}
//               onChange={handleStaffChange}
//               disabled={isStaffLocked || !selectedManager}
//             >
//               <option value="">Select Staff</option>
//               {staffList.map(staff => (
//                 <option key={staff.id} value={staff.name}>
//                   {staff.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Item Entry */}
//         <div className="card p-2 mt-1">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label>Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label>Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={newItem.other_name}
//                   onChange={(e) => setNewItem({ ...newItem, other_name: e.target.value })}
//                 />
//               </div>
//             )}

//             <div className="col-md-2">
//               <label>Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) => setNewItem({ ...newItem, category: e.target.value })}
//               >
//                 <option value="">Select</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label>Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) => setNewItem({ ...newItem, type: e.target.value })}
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select</option>
//                 {productTypes.map((t) => (
//                   <option key={t._id} value={t.type}>
//                     {t.type}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-1">
//               <label>Weight (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   if (/^\d*\.?\d*$/.test(e.target.value))
//                     setNewItem({ ...newItem, weight: e.target.value });
//                 }}
//               />
//             </div>

//             {/* Adjustment */}
//             <div className="col-md-2">
//               <label>Adjustment</label>
//               <div className="input-group">
//                 <button
//                   className="btn btn-outline-danger btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem((p) => ({
//                         ...p,
//                         adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(3),
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-minus"></i>
//                 </button>

//                 <input
//                   type="text"
//                   className="form-control form-control-sm text-center"
//                   style={{ width: "60px" }}
//                   value={adjustmentInput}
//                   placeholder="0.00"
//                   onChange={(e) => {
//                     if (/^\d*\.?\d*$/.test(e.target.value)) setAdjustmentInput(e.target.value);
//                   }}
//                   onKeyPress={(e) => {
//                     if (e.key === "Enter") {
//                       const v = parseFloat(adjustmentInput) || 0;
//                       if (v > 0) {
//                         setNewItem((p) => ({
//                           ...p,
//                           adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
//                         }));
//                         setAdjustmentInput("");
//                       }
//                     }
//                   }}
//                 />

//                 <button
//                   className="btn btn-outline-success btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem((p) => ({
//                         ...p,
//                         adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-plus"></i>
//                 </button>
//               </div>

//               {parseFloat(newItem.adjustment || 0) !== 0 && (
//                 <button
//                   className="position-absolute text-danger"
//                   style={{ right: "10px", top: "35px", background: "none", border: "none" }}
//                   onClick={() => setNewItem((p) => ({ ...p, adjustment: "0.000" }))}
//                 >
//                   ×
//                 </button>
//               )}
//             </div>

//             <div className="col-md-1">
//               <label>Purity (%)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   if (/^\d{0,3}(\.\d{0,2})?$/.test(e.target.value)) {
//                     const v = parseFloat(e.target.value);
//                     if (v <= 100 || e.target.value === "") {
//                       setNewItem({ ...newItem, purity: e.target.value });
//                     } else {
//                       toast.error("Max 100%", 3000, "topRight");
//                     }
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label>Pure (g)</label>
//               <input type="text" className="form-control" value={newItem.pure} readOnly />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button className="btn btn-success btn-sm mt-4" onClick={handleAddItem}>
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button className="btn btn-info btn-sm mt-4" onClick={handleUpdateItem}>
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Items Table + Summary */}
//         <div className="row mt-2">
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <h6>Item List</h6>
//               <table className="table table-sm">
//                 <thead className="bg-light">
//                   <tr>
//                     <th>S.No</th>
//                     <th>Item</th>
//                     <th>Cat</th>
//                     <th>Type</th>
//                     <th>Weight</th>
//                     <th>Purity</th>
//                     <th>Pure</th>
//                     <th>Adjustment</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {formData.items.map((item, i) => (
//                     <tr key={item.id}>
//                       <td>{i + 1}</td>
//                       <td>
//                         {item.item}
//                         {item.other_name && ` (${item.other_name})`}
//                       </td>
//                       <td>{item.category}</td>
//                       <td>{item.type || "-"}</td>
//                       <td>{parseFloat(item.weight).toFixed(3)}</td>
//                       <td>{parseFloat(item.purity).toFixed(2)}%</td>
//                       <td>{parseFloat(item.pure).toFixed(3)}</td>
//                       <td className="text-end">
//                         <span className={item.adjustment > 0 ? "text-success" : "text-danger"}>
//                           {item.adjustment > 0 ? "+" : ""}
//                           {parseFloat(item.adjustment || 0).toFixed(3)}
//                         </span>
//                       </td>
//                       <td>
//                         <button className="btn btn-sm btn-light" onClick={() => handleEditItem(item.id)}>
//                           <i className="fa-solid fa-pen-to-square text-primary"></i>
//                         </button>
//                         <button className="btn btn-sm btn-light" onClick={() => handleRemoveItem(item.id)}>
//                           <i className="fa-solid fa-trash text-danger"></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                   {formData.items.length === 0 && (
//                     <tr><td colSpan="9" className="text-center">No items</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Summary */}
//           <div className="col-lg-3">
//             <div className="card p-3">
//               <div className="row mb-2">
//                 <div className="col-6">Total Pure (g)</div>
//                 <div className="col-6"><input className="form-control" value={formData.total_pure} readOnly /></div>
//               </div>

//               <div className="row mb-2">
//                 <div className="col-6">Return Type</div>
//                 <div className="col-6">
//                   <select
//                     className="form-select"
//                     value={formData.return_type}
//                     onChange={(e) => {
//                       setFormData({
//                         ...formData,
//                         return_type: e.target.value,
//                         pure: "",
//                         paid: "",
//                         enter_amount: "",
//                       });
//                       setReturnPureCalculated("0.000");
//                     }}
//                   >
//                     <option value="">Select</option>
//                     <option value="Pure">Pure</option>
//                     <option value="Amount">Amount</option>
//                   </select>
//                 </div>
//               </div>

//               {formData.return_type === "Pure" && (
//                 <div className="row mb-2">
//                   <div className="col-6">Return Pure (g)</div>
//                   <div className="col-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={formData.pure}
//                       onChange={(e) => {
//                         if (/^\d*\.?\d*$/.test(e.target.value))
//                           setFormData({ ...formData, pure: e.target.value });
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}

//               {formData.return_type === "Amount" && (
//                 <>
//                   {/* <div className="row mb-2">
//                     <div className="col-6"><strong>Enter Amount (₹)</strong></div>
//                     <div className="col-6"><input className="form-control" value={formData.enter_amount || "0.00"} readOnly /></div>
//                   </div> */}
//                   <div className="row mb-2">
//                     <div className="col-6">Paid (₹)</div>
//                     <div className="col-6">
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={formData.paid}
//                         onChange={(e) => {
//                           if (/^\d*\.?\d*$/.test(e.target.value))
//                             setFormData({ ...formData, paid: e.target.value });
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="row mb-2">
//                     <div className="col-6">Return Pure (g)</div>
//                     <div className="col-6"><input className="form-control bg-light" value={returnPureCalculated} readOnly /></div>
//                   </div>
//                 </>
//               )}

//               <div className="row mb-2">
//                 <div className="col-6">Opening (g)</div>
//                 <div className="col-6"><input className="form-control" value={formData.opening} readOnly /></div>
//               </div>
//               <div className="row mb-2">
//                 <div className="col-6">Current (g)</div>
//                 <div className="col-6"><input className="form-control" value={formData.current} readOnly /></div>
//               </div>
//               <div className="row mb-2">
//                 <div className="col-6">Closing (g)</div>
//                 <div className="col-6"><input className="form-control" value={formData.close} readOnly /></div>
//               </div>

//               <div className="d-flex justify-content-between mt-3">
//                 <button className="btn btn-secondary btn-sm" onClick={() => navigate("/retailers")}>
//                   Back
//                 </button>
//                 <button className="btn btn-danger btn-sm" onClick={handleClear}>
//                   Clear
//                 </button>
//                 <button className="btn btn-primary btn-sm" onClick={handlePrint} disabled={loading}>
//                   Print
//                 </button>
//                 <button className="btn btn-success btn-sm" onClick={handleSave} disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Modal */}
//       {showModal && (
//         <>
//           <div className="modal fade show" style={{ display: "block" }}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h6>Print Confirmation</h6>
//                   <button className="btn-close" onClick={() => setShowModal(false)}></button>
//                 </div>
//                 <div className="modal-body text-center">
//                   <p>Do you want to print the retailer bill?</p>
//                   <button className="btn btn-secondary mx-2" onClick={() => navigate("/retailers")}>
//                     Cancel
//                   </button>
//                   <button className="btn btn-primary" onClick={closeModal}>
//                     Print
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal-backdrop fade show"></div>
//         </>
//       )}
//     </>
//   );
// }

// export default AddRetailer;


// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";

// function AddRetailer({ toggleSidebar }) {
//   const navigate = useNavigate();
//   const { retailerId } = useParams();
//   const toast = useToast();

//   const [loading, setLoading] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [productTypes, setProductTypes] = useState([]);
//   const [suppliers, setSuppliers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const [userdata, setUserdata] = useState([]);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [staffList, setStaffList] = useState([]);
//   const [isManagerLocked, setIsManagerLocked] = useState(false);
//   const [isStaffLocked, setIsStaffLocked] = useState(false);

//   // New item state
//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: 1,
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//     adjustment: "0.000",
//   });

//   const [adjustmentInput, setAdjustmentInput] = useState("");

//   const [todayRates, setTodayRates] = useState({
//     gold_pure_rate: 0,
//     silver_pure_rate: 0,
//     date: "",
//   });

//   const [returnPureCalculated, setReturnPureCalculated] = useState("0.000");

//   // Form data
//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: new Date().toISOString().split("T")[0],
//     supplier_id: "",
//     return_type: "",
//     enter_amount: "",
//     paid: "0",
//     pure: "0",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     manager: "",
//     manager_name: "",
//     adjustment: "0.000",
//     staff: "",
//     items: [],
//     supplier_details: {
//       supplier_id: "",
//       name: null,
//       mobile: null,
//       address: null,
//     },
//   });

//   // Fetch today's rates
//   const fetchTodayRates = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/current`);
//       if (response.data.status && response.data.data) {
//         const rates = response.data.data;
//         setTodayRates({
//           gold_pure_rate: parseFloat(rates.gold_pure_percentage) || 0,
//           silver_pure_rate: parseFloat(rates.silver_pure_percentage) || 0,
//           date: rates.date,
//         });
//       }
//     } catch (error) {
//       console.error("Failed to fetch today's rates", error);
//     }
//   };

//   // Calculate pure for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight) || 0;
//       const purity = parseFloat(newItem.purity) || 0;
//       const quantity = parseFloat(newItem.quantity) || 1;

//       if (purity > 100) {
//         toast.error("Purity cannot exceed 100%", 3000, "topRight");
//         setNewItem((prev) => ({ ...prev, purity: "" }));
//         return;
//       }

//       const singlePure = (weight * purity) / 100;
//       let calculatedPure = quantity * singlePure;

//       const adjustment = parseFloat(newItem.adjustment) || 0;
//       calculatedPure += adjustment;

//       pure = calculatedPure.toFixed(3);
//       total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment]);

//   // Total pure from all items
//   useEffect(() => {
//     const totalPure = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);

//     const totalAmount = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
//       .toFixed(3);

//     setFormData(prev => ({
//       ...prev,
//       total_pure: totalPure,
//       total_amount: totalAmount  // if needed for Amount mode
//     }));
//   }, [formData.items]);

//   // MAIN CALCULATION – Current, Return Pure, Closing
//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     const totalPure = parseFloat(formData.total_pure) || 0;

//     // STEP 1: Current is ALWAYS opening + total_pure (in grams)
//     const current = (opening + totalPure).toFixed(3);

//     let returnedPureGrams = 0;
//     let validationError = false;

//     // STEP 2: Calculate returned pure grams based on return type
//     if (formData.return_type === "Pure") {
//       // Direct grams input
//       const pureInput = parseFloat(formData.pure) || 0;

//       // VALIDATION: Return pure cannot exceed CURRENT (not total_pure)
//       if (pureInput > parseFloat(current)) {
//         toast.error("Return Pure cannot exceed Current", 3000, "topRight");
//         validationError = true;
//       } else {
//         returnedPureGrams = pureInput;
//       }
//     } else if (formData.return_type === "Amount") {
//       // Convert paid amount to grams using rate
//       const paid = parseFloat(formData.paid) || 0;

//       if (paid > 0) {
//         const hasGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//         const hasSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

//         let rate = 0;
//         if (hasGold && !hasSilver) {
//           rate = todayRates.gold_pure_rate;
//         } else if (hasSilver && !hasGold) {
//           rate = todayRates.silver_pure_rate;
//         }

//         if (rate > 0) {
//           returnedPureGrams = paid / rate;

//           // VALIDATION: Converted pure cannot exceed CURRENT
//           if (returnedPureGrams > parseFloat(current)) {
//             toast.error("Paid amount exceeds available current balance", 3000, "topRight");
//             validationError = true;
//             returnedPureGrams = 0;
//           } else {
//             setReturnPureCalculated(returnedPureGrams.toFixed(3));
//           }
//         }
//       } else {
//         setReturnPureCalculated("0.000");
//       }
//     }

//     // STEP 3: Closing = Current - Returned (in grams)
//     // FIX: Was "paid - current", now correctly "current - returnedPureGrams"
//     const closing = Math.max(0, parseFloat(current) - returnedPureGrams).toFixed(3);

//     setFormData(prev => ({
//       ...prev,
//       current,
//       close: validationError ? prev.close : closing
//     }));
//   }, [
//     formData.opening,
//     formData.total_pure,
//     formData.pure,
//     formData.paid,
//     formData.return_type,
//     formData.items,
//     todayRates.gold_pure_rate,
//     todayRates.silver_pure_rate,
//     toast
//   ]);

//   // Amount mode: calculate enter_amount from total pure
//   useEffect(() => {
//     if (formData.return_type !== "Amount" || formData.items.length === 0) {
//       setFormData(prev => ({ ...prev, enter_amount: "" }));
//       return;
//     }

//     let goldPure = 0, silverPure = 0;
//     formData.items.forEach(item => {
//       const pure = parseFloat(item.pure) || 0;
//       if ((item.category === "Gold" || item.category === "Gold Coin")) goldPure += pure;
//       if ((item.category === "Silver" || item.category === "Silver Coin")) silverPure += pure;
//     });

//     const goldValue = goldPure * todayRates.gold_pure_rate;
//     const silverValue = silverPure * todayRates.silver_pure_rate;
//     const total = (goldValue + silverValue).toFixed(2);

//     setFormData(prev => ({ ...prev, enter_amount: total }));
//   }, [formData.items, formData.return_type, todayRates]);

//   useEffect(() => {
//     const current = parseFloat(formData.current) || 0;
//     let close = current.toFixed(3);

//     if (formData.return_type === "Pure") {
//       const pureReturn = parseFloat(formData.pure || 0);
//       // const totalPure = parseFloat(formData.total_pure || 0);

//       if (pureReturn > current) {
//         toast.error("Return Pure cannot exceed Current", 3000, "topRight");
//         setFormData(prev => ({ ...prev, pure: "" }));
//         return;
//       }
//       close = (current - pureReturn).toFixed(3);
//     } else if (formData.return_type === "Amount") {
//       // const paid = parseFloat(formData.paid || 0);
//       const return_pure = parseFloat(formData.return_pure || 0)
//       // const enterAmount = parseFloat(formData.enter_amount || 0);

//       if (return_pure > current) {
//         toast.error("Paid amount cannot exceed Current", 3000, "topRight");
//         setFormData(prev => ({ ...prev, paid: "" }));
//         return;
//       }
//       close = (current - return_pure).toFixed(3);
//     }

//     // Ensure close doesn't go negative
//     if (parseFloat(close) < 0) {
//       close = "0.000";
//     }

//     setFormData(prev => ({ ...prev, close }));
//   }, [
//     formData.current,
//     formData.pure,
//     formData.paid,
//     formData.total_pure,
//     formData.enter_amount,
//     formData.return_type
//   ]);

//   // Reset type when item is Bar
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem(prev => ({ ...prev, type: "", purity: "100" }));
//     }
//   }, [newItem.item]);

//   // Initial load
//   useEffect(() => {
//     toggleSidebar();
//     fetchInitialData();
//     fetchTodayRates();
//     fetchUserData();
//     fetchLoggedInUser();
//     if (retailerId) {
//       fetchRetailerData(retailerId);
//     }
//   }, [retailerId]);

//   const fetchInitialData = async () => {
//     try {
//       const idResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
//       );
//       setGenerateNumber(idResponse.data.retailer_id || "");
//       if (!retailerId) {
//         setFormData((prev) => ({
//           ...prev,
//           retailer_id: idResponse.data.retailer_id || "",
//         }));
//       }

//       const supplierResponse = await axios.get(`${ApiUrl}/Api/supplier.php`);
//       setSuppliers(supplierResponse.data?.data || []);

//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form", 3000, "topRight");
//     }
//   };

//   const fetchRetailerData = async (id) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php?id=${id}`
//       );
//       const data = response.data.data[0];

//       if (data) {
//         setFormData({
//           retailer_id: data.retailer_id,
//           retailer_date: data.retailer_date,
//           supplier_id: data.supplier_id,
//           return_type: data.return_type || "",
//           enter_amount: data.enter_amount || "",
//           paid: data.paid || "0",
//           pure: data.pure || "0",
//           opening: parseFloat(data.opening || 0).toFixed(3),
//           current: parseFloat(data.current || 0).toFixed(3),
//           close: parseFloat(data.close || 0).toFixed(3),
//           total_pure: parseFloat(data.total_pure || 0).toFixed(3),
//           items: data.items.map((item, index) => ({
//             id: index + 1,
//             item: item.item,
//             other_name: item.other_name || "",
//             category: item.category,
//             type: item.type || "",
//             quantity: parseFloat(item.quantity) || 0,
//             weight: parseFloat(item.weight) || 0,
//             purity: parseFloat(item.percentage) || 0,
//             pure: parseFloat(item.pure) || 0,
//             total_amount: parseFloat(item.total_amount) || 0,
//             adjustment: parseFloat(item.adjustment) || 0,
//           })),
//           supplier_details: { ...data.supplier },
//           manager: data.manager || "",
//           manager_name: data.manager_name || "",
//           staff: data.staff || "",
//         });

//         setSelectedSupplier(data.supplier);
//         setSearchTerm(
//           `${data.supplier.supplier_id} - ${data.supplier.name}`
//         );
//         setGenerateNumber(data.retailer_id);
//       }
//     } catch (error) {
//       console.error("Error loading retailer:", error);
//       toast.error("Failed to load retailer data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!selectedSupplier?.supplier_id || formData.items.length === 0) {
//       setFormData(prev => ({ ...prev, opening: "0.000" }));
//       return;
//     }

//     const fetchOpening = async () => {
//       try {
//         const res = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//         const retailers = res.data?.data || [];

//         // Determine current metal category from items
//         const currentGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//         const currentSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

//         if (!currentGold && !currentSilver) {
//           setFormData(prev => ({ ...prev, opening: "0.000" }));
//           return;
//         }

//         // Filter all previous retailers for this supplier
//         const supplierRetailers = retailers
//           .filter(r => r.supplier_id === selectedSupplier.supplier_id)
//           .sort((a, b) => new Date(b.retailer_date) - new Date(a.retailer_date));

//         if (supplierRetailers.length === 0) {
//           setFormData(prev => ({ ...prev, opening: "0.000" }));
//           return;
//         }

//         // Find the most recent retailer that matches the current metal type
//         const latestMatching = supplierRetailers.find(retailer => {
//           const hasGold = retailer.items?.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//           const hasSilver = retailer.items?.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

//           if (currentGold && !currentSilver) return hasGold && !hasSilver;
//           if (currentSilver && !currentGold) return hasSilver && !hasGold;
//           if (currentGold && currentSilver) return hasGold && hasSilver;
//           return false;
//         });

//         const opening = latestMatching
//           ? parseFloat(latestMatching.close || 0).toFixed(3)
//           : "0.000";

//         setFormData(prev => ({ ...prev, opening }));
//       } catch (err) {
//         console.error("Error fetching opening balance", err);
//         setFormData(prev => ({ ...prev, opening: "0.000" }));
//       }
//     };

//     fetchOpening();
//   }, [selectedSupplier?.supplier_id, formData.items]);

//   const handleSelectSupplier = async (supplier) => {
//     setSelectedSupplier(supplier);
//     setSearchTerm(`${supplier.supplier_id} - ${supplier.name}`);
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: supplier.supplier_id,
//       supplier_details: { ...supplier },
//       opening: "0.000",
//     }));
//     setShowDropdown(false);
//   };

//   const clearSupplier = () => {
//     setSelectedSupplier(null);
//     setSearchTerm("");
//     setFormData((prev) => ({
//       ...prev,
//       supplier_id: "",
//       supplier_details: { supplier_id: "", name: null, mobile: null, address: null },
//       opening: "0.000",
//     }));
//   };

//   // Item functions
//   const validateItem = () => {
//     if (!newItem.item) return toast.error("Select item", 3000, "topRight"), false;
//     if (!newItem.category) return toast.error("Select category", 3000, "topRight"), false;
//     if (newItem.item !== "Bar" && !newItem.type)
//       return toast.error("Select type", 3000, "topRight"), false;
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0)
//       return toast.error("Valid quantity required", 3000, "topRight"), false;
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0)
//       return toast.error("Valid weight required", 3000, "topRight"), false;
//     if (!newItem.purity || parseFloat(newItem.purity) <= 0 || parseFloat(newItem.purity) > 100)
//       return toast.error("Valid purity (0-100%)", 3000, "topRight"), false;
//     if (newItem.item === "Others" && !newItem.other_name)
//       return toast.error("Enter name for Others", 3000, "topRight"), false;
//     return true;
//   };

//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...formData.items,
//       {
//         id: formData.items.length + 1,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 1,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//         adjustment: parseFloat(newItem.adjustment) || 0,
//       },
//     ];

//     setFormData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updated = formData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//           ...item,
//           item: newItem.item,
//           other_name: newItem.other_name,
//           category: newItem.category,
//           type: newItem.type,
//           quantity: parseFloat(newItem.quantity) || 1,
//           weight: parseFloat(newItem.weight) || 0,
//           purity: parseFloat(newItem.purity) || 0,
//           pure: parseFloat(newItem.pure) || 0,
//           total_amount: parseFloat(newItem.total_amount) || 0,
//           adjustment: parseFloat(newItem.adjustment) || 0,
//         }
//         : item
//     );

//     setFormData((prev) => ({ ...prev, items: updated }));
//     resetNewItem();
//   };

//   const handleEditItem = (id) => {
//     const item = formData.items.find((i) => i.id === id);
//     if (item) {
//       setNewItem({
//         item: item.item,
//         category: item.category,
//         other_name: item.other_name || "",
//         type: item.type || "",
//         quantity: item.quantity.toString(),
//         weight: item.weight.toString(),
//         purity: item.purity.toString(),
//         pure: item.pure.toFixed(3),
//         total_amount: item.total_amount.toFixed(3),
//         adjustment: (item.adjustment || 0).toFixed(3),
//       });
//       setAdjustmentInput("");
//       setEditingItemId(id);
//     }
//   };

//   const handleRemoveItem = (id) => {
//     const filtered = formData.items
//       .filter((i) => i.id !== id)
//       .map((i, idx) => ({ ...i, id: idx + 1 }));
//     setFormData((prev) => ({ ...prev, items: filtered }));
//   };

//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: 1,
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//       adjustment: "0.000",
//     });
//     setAdjustmentInput("");
//     setEditingItemId(null);
//   };

//   const validateForm = () => {
//     if (!formData.retailer_id) return toast.error("Retailer ID required", 3000, "topRight"), false;
//     if (!formData.retailer_date) return toast.error("Date required", 3000, "topRight"), false;
//     if (!formData.supplier_id) return toast.error("Select supplier", 3000, "topRight"), false;
//     if (formData.items.length === 0) return toast.error("Add at least one item", 3000, "topRight"), false;
//     if (!formData.return_type) return toast.error("Select return type", 3000, "topRight"), false;

//     // FIX: Check against CURRENT, not total_pure
//     if (formData.return_type === "Pure") {
//       const pureReturn = parseFloat(formData.pure);
//       const current = parseFloat(formData.current);

//       if (!pureReturn || pureReturn <= 0) {
//         return toast.error("Enter valid pure return", 3000, "topRight"), false;
//       }

//       if (pureReturn > current) {
//         return toast.error("Return Pure cannot exceed Current", 3000, "topRight"), false;
//       }
//     }

//     if (formData.return_type === "Amount") {
//       const return_pure = parseFloat(formData.return_pure);
//       const paid = parseFloat(formData.paid);
//       const current = parseFloat(formData.current);
//       const enterAmount = parseFloat(formData.enter_amount);

//       if (!paid || paid <= 0) {
//         return toast.error("Enter valid paid amount", 3000, "topRight"), false;
//       }

//       // Check if paid amount (converted to grams) exceeds current
//       const hasGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//       const hasSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));
//       let rate = 0;

//       if (hasGold && !hasSilver) {
//         rate = todayRates.gold_pure_rate;
//       } else if (hasSilver && !hasGold) {
//         rate = todayRates.silver_pure_rate;
//       }

//       if (rate > 0) {
//         const paidInGrams = paid / rate;
//         if (paidInGrams > current) {
//           return toast.error("Paid amount exceeds available current balance", 3000, "topRight"), false;
//         }
//       }

//       if (return_pure > current) {
//         return toast.error("Paid amount cannot exceed Enter Amount", 3000, "topRight"), false;
//       }
//     }

//     if (!formData.manager) return toast.error("Select manager", 3000, "topRight"), false;
//     if (!formData.staff) return toast.error("Select staff", 3000, "topRight"), false;
//     return true;
//   };


//   const preparePayload = () => {
//     const payload = {
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       supplier_id: formData.supplier_id,
//       return_type: formData.return_type,
//       enter_amount: parseFloat(formData.enter_amount) || 0,
//       paid: parseFloat(formData.paid) || 0,
//       pure: parseFloat(formData.pure) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       manager: formData.manager || "",
//       manager_name: formData.manager_name || "",
//       staff: formData.staff || "",
//       items: formData.items.map((i) => ({
//         category: i.category,
//         quantity: i.quantity,
//         item: i.item,
//         weight: i.weight,
//         type: i.type || "",
//         other_name: i.other_name || "",
//         percentage: i.purity,
//         pure: i.pure,
//         total_amount: i.total_amount,
//         adjustment: i.adjustment,
//         retailer_id: formData.retailer_id,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.enter_amount = 0;
//       payload.paid = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     }

//     return payload;
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       console.log("=== PAYLOAD BEING SENT ===");
//       console.log(JSON.stringify(payload, null, 2));
//       console.log("=== ITEMS DETAIL ===");
//       payload.items.forEach((item, index) => {
//         console.log(`Item ${index}:`, {
//           category: item.category,
//           adjustment: item.adjustment,
//           pure: item.pure
//         });
//       });
//       const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

//       if (res.status === 200 || res.status === 201) {
//         toast.success("Retailer saved!", 3000, "topRight");
//         handleClear();
//         await fetchInitialData();
//         navigate("/retailers");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Save failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

//       if (res.status === 200 || res.status === 201) {
//         toast.success("Saved for print", 3000, "topRight");
//         setShowModal(true);
//       }
//     } catch (err) {
//       toast.error("Print failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClear = () => {
//     setFormData({
//       retailer_id: generateNumber,
//       retailer_date: new Date().toISOString().split("T")[0],
//       supplier_id: "",
//       return_type: "",
//       enter_amount: "",
//       paid: "0",
//       pure: "0",
//       opening: "0.000",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       items: [],
//       supplier_details: { supplier_id: "", name: null, mobile: null, address: null },
//       manager: "",
//       manager_name: "",
//       staff: "",
//     });
//     resetNewItem();
//     clearSupplier();
//     setSearchTerm("");
//     setReturnPureCalculated("0.000");
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     handleClear();
//     navigate(`/retailer-bill/${formData.retailer_id}`);
//   };

//   const fetchLoggedInUser = () => {
//     try {
//       const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//       if (userInfo && userInfo.user_id) {
//         setLoggedInUser(userInfo);
//       }
//     } catch (error) {
//       console.error("Error reading logged-in user:", error);
//     }
//   };

//   const fetchUserData = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}/Api/user.php`);
//       const users = Array.isArray(res.data.data) ? res.data.data : [];
//       setUserdata(users);
//     } catch (err) {
//       console.error("Failed to fetch users", err);
//       toast.error("Failed to load staff data", 3000, 'topRight');
//     }
//   };

//   useEffect(() => {
//     if (!loggedInUser || userdata.length === 0) return;

//     const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
//     if (!currentUser) return;

//     if (currentUser.role === "Manager" || currentUser.role === "manager") {
//       setSelectedManager(currentUser.id.toString());
//       setIsManagerLocked(true);

//       const staff = userdata.filter(
//         u => u.manager_id === currentUser.user_id && (u.role === "Employee" || u.role === "employee")
//       );
//       setStaffList(staff);

//       setFormData(prev => ({
//         ...prev,
//         manager: currentUser.user_id,
//         manager_name: currentUser.name,
//       }));
//     }
//     else if (currentUser.role === "Employee" || currentUser.role === "employee") {
//       setSelectedStaff(currentUser.name);
//       setIsStaffLocked(true);

//       const manager = userdata.find(
//         u => u.user_id === currentUser.manager_id && (u.role === "Manager" || u.role === "manager")
//       );

//       if (manager) {
//         setSelectedManager(manager.id.toString());
//         setIsManagerLocked(true);

//         const staffUnderManager = userdata.filter(
//           u => u.manager_id === manager.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staffUnderManager);

//         setFormData(prev => ({
//           ...prev,
//           manager: manager.user_id,
//           manager_name: manager.name,
//           staff: currentUser.name,
//         }));
//       }
//     }
//   }, [loggedInUser, userdata]);

//   const handleManagerChange = (e) => {
//     if (isManagerLocked) return;
//     const managerId = e.target.value;
//     setSelectedManager(managerId);
//     setSelectedStaff("");
//     setStaffList([]);

//     if (managerId) {
//       const managerObj = userdata.find(u => u.id === parseInt(managerId));
//       if (managerObj) {
//         const staff = userdata.filter(
//           u => u.manager_id === managerObj.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staff);

//         setFormData(prev => ({
//           ...prev,
//           manager: managerObj.user_id,
//           manager_name: managerObj.name,
//         }));
//       }
//     } else {
//       setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
//     }
//   };

//   const handleStaffChange = (e) => {
//     if (isStaffLocked) return;
//     const staffName = e.target.value;
//     setSelectedStaff(staffName);
//     setFormData(prev => ({ ...prev, staff: staffName }));
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid py-2">
//         {/* Header */}
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Retailer ID</label>
//                   <input type="text" className="form-control" value={generateNumber} readOnly />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={formData.retailer_date}
//                     onChange={(e) =>
//                       setFormData((p) => ({ ...p, retailer_date: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Supplier Section */}
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-3 position-relative">
//                   <label className="form-label">Supplier</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search supplier..."
//                       value={searchTerm}
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button className="btn btn-outline-secondary" onClick={clearSupplier}>
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && suppliers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {suppliers
//                         .filter(
//                           (s) =>
//                             s.supplier_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                             s.name.toLowerCase().includes(searchTerm.toLowerCase())
//                         )
//                         .map((s) => (
//                           <button
//                             key={s.supplier_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectSupplier(s)}
//                             type="button"
//                           >
//                             {s.supplier_id} - {s.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.supplier_details?.name || ""}
//                     disabled
//                     style={{ backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.supplier_details?.mobile || ""}
//                     disabled
//                     style={{ backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <label className="form-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={formData.supplier_details?.address || ""}
//                     disabled
//                     style={{ backgroundColor: "#f0f0f0" }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row mt-3">
//           <div className="col-md-3">
//             <label className="form-label">
//               Manager <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedManager}
//               onChange={handleManagerChange}
//               disabled={isManagerLocked}
//             >
//               <option value="">Select Manager</option>
//               {userdata
//                 .filter(u => u.role === "Manager" || u.role === "manager")
//                 .map(manager => (
//                   <option key={manager.id} value={manager.id}>
//                     {manager.name}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">
//               Staff <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedStaff}
//               onChange={handleStaffChange}
//               disabled={isStaffLocked || !selectedManager}
//             >
//               <option value="">Select Staff</option>
//               {staffList.map(staff => (
//                 <option key={staff.id} value={staff.name}>
//                   {staff.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Item Entry */}
//         <div className="card mt-1  py-2">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label>Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label>Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={newItem.other_name}
//                   onChange={(e) => setNewItem({ ...newItem, other_name: e.target.value })}
//                 />
//               </div>
//             )}

//             <div className="col-md-2">
//               <label>Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) => setNewItem({ ...newItem, category: e.target.value })}
//               >
//                 <option value="">Select</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label>Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) => setNewItem({ ...newItem, type: e.target.value })}
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select</option>
//                 {productTypes.map((t) => (
//                   <option key={t._id} value={t.type}>
//                     {t.type}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* <div className="col-md-1">
//               <label>Qty</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   if (/^\d*$/.test(e.target.value)) {
//                     setNewItem({ ...newItem, quantity: e.target.value || "1" });
//                   }
//                 }}
//               />
//             </div> */}

//             <div className="col-md-1">
//               <label>Weight (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   if (/^\d*\.?\d*$/.test(e.target.value))
//                     setNewItem({ ...newItem, weight: e.target.value });
//                 }}
//               />
//             </div>

//             {/* Adjustment with proper X button */}
//             <div className="col-md-2 position-relative">
//               <label>Adjustment</label>
//               <div className="input-group">
//                 <button
//                   className="btn btn-outline-danger btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem((p) => ({
//                         ...p,
//                         adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(3),
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-minus"></i>
//                 </button>

//                 <input
//                   type="text"
//                   className="form-control form-control-sm text-center"
//                   value={adjustmentInput}
//                   placeholder="0.000"
//                   onChange={(e) => {
//                     if (/^\d*\.?\d*$/.test(e.target.value)) setAdjustmentInput(e.target.value);
//                   }}
//                   onKeyPress={(e) => {
//                     if (e.key === "Enter") {
//                       const v = parseFloat(adjustmentInput) || 0;
//                       if (v > 0) {
//                         setNewItem((p) => ({
//                           ...p,
//                           adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
//                         }));
//                         setAdjustmentInput("");
//                       }
//                     }
//                   }}
//                 />

//                 <button
//                   className="btn btn-outline-success btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem((p) => ({
//                         ...p,
//                         adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-plus"></i>
//                 </button>

//                 {parseFloat(newItem.adjustment || 0) !== 0 && (
//                   <button
//                     className="btn btn-sm translate-middle-y me-1"
//                     style={{ zIndex: 10, background: "none", border: "none", position: "relative", top: "10px", right: "50px" }}
//                     onClick={() => setNewItem((p) => ({ ...p, adjustment: "0.000" }))}
//                   >
//                     <i className="fa-solid fa-xmark text-danger"></i>
//                   </button>
//                 )}
//               </div>
//               {/* <small className="text-muted d-block text-center mt-1">
//                 Current: {parseFloat(newItem.adjustment || 0).toFixed(3)}g
//               </small> */}
//             </div>

//             <div className="col-md-1">
//               <label>Purity (%)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
//                     const num = parseFloat(value);
//                     if (!value || num <= 100) {
//                       setNewItem({ ...newItem, purity: value });
//                     }
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label>Pure (g)</label>
//               <input type="text" className="form-control" value={newItem.pure} readOnly />
//             </div>

//             <div className="col-md-1 p-4">
//               {editingItemId === null ? (
//                 <button className="btn btn-success btn-sm" onClick={handleAddItem}>
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button className="btn btn-info btn-sm" onClick={handleUpdateItem}>
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Items Table + Summary */}
//         <div className="row mt-2">
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <h6>Item List</h6>
//               <table className="table table-sm">
//                 <thead className="bg-light">
//                   <tr>
//                     <th>S.No</th>
//                     <th>Item</th>
//                     <th>Qty</th>
//                     <th>Cat</th>
//                     <th>Type</th>
//                     <th>Weight</th>
//                     <th>Purity</th>
//                     <th>Pure</th>
//                     <th>adjustment</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {formData.items.map((item, i) => (
//                     <tr key={item.id}>
//                       <td>{i + 1}</td>
//                       <td>
//                         {item.item}
//                         {item.other_name && ` (${item.other_name})`}
//                       </td>
//                       <td>{item.quantity}</td>
//                       <td>{item.category}</td>
//                       <td>{item.type || "-"}</td>
//                       <td>{parseFloat(item.weight).toFixed(3)}</td>
//                       <td>{parseFloat(item.purity).toFixed(2)}%</td>
//                       <td>{parseFloat(item.pure).toFixed(3)}</td>
//                       <td className="text-start">
//                         <span className={item.adjustment > 0 ? "text-success" : item.adjustment < 0 ? "text-danger" : ""}>
//                           {item.adjustment > 0 ? "+" : ""}
//                           {parseFloat(item.adjustment || 0).toFixed(3)}
//                         </span>
//                       </td>
//                       <td>
//                         <button className="btn btn-sm btn-light" onClick={() => handleEditItem(item.id)}>
//                           <i className="fa-solid fa-pen-to-square text-primary"></i>
//                         </button>
//                         <button className="btn btn-sm btn-light" onClick={() => handleRemoveItem(item.id)}>
//                           <i className="fa-solid fa-trash text-danger"></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                   {formData.items.length === 0 && (
//                     <tr><td colSpan="10" className="text-center">No items</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Summary */}
//           <div className="col-lg-3">
//             <div className="card p-3">
//               <div className="row mb-2">
//                 <div className="col-6">Total Pure (g)</div>
//                 <div className="col-6">
//                   <input type="text" className="form-control" value={formData.total_pure || "0.000"} readOnly />
//                 </div>
//               </div>

//               <div className="row mb-2">
//                 <div className="col-6">Return Type</div>
//                 <div className="col-6">
//                   <select
//                     className="form-select"
//                     value={formData.return_type}
//                     onChange={(e) => {
//                       const newReturnType = e.target.value;
//                       setFormData({
//                         ...formData,
//                         return_type: newReturnType,
//                         pure: "",
//                         paid: "",
//                         enter_amount: "",
//                       });
//                       setReturnPureCalculated("0.000");
//                     }}
//                   >
//                     <option value="">Select</option>
//                     <option value="Pure">Pure</option>
//                     <option value="Amount">Amount</option>
//                   </select>
//                 </div>
//               </div>

//               {/* PURE MODE */}
//               {formData.return_type === "Pure" && (
//                 <div className="row mb-2">
//                   <div className="col-6">
//                     <label className="form-label">Return Pure (g)</label>
//                     {/* <small className="text-muted d-block">Max: {formData.current}</small> */}
//                   </div>
//                   <div className="col-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="0.000"
//                       value={formData.pure}
//                       onChange={(e) => {
//                         if (/^\d*\.?\d*$/.test(e.target.value))
//                           setFormData({ ...formData, pure: e.target.value });
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* AMOUNT MODE */}
//               {formData.return_type === "Amount" && (
//                 <>
//                   {/* <div className="row mb-2">
//                     <div className="col-6">Enter Amount (₹)</div>
//                     <div className="col-6">
//                       <input
//                         type="text"
//                         className="form-control bg-light"
//                         value={formData.enter_amount || "0.00"}
//                         readOnly
//                       />
//                     </div>
//                   </div> */}
//                   <div className="row mb-2">
//                     <div className="col-6">
//                       <label className="form-label">Paid (₹)</label>
//                       {/* <small className="text-muted d-block">Max: {formData.enter_amount || "0.00"}</small> */}
//                     </div>
//                     <div className="col-6">
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="0.00"
//                         value={formData.paid}
//                         onChange={(e) => {
//                           if (/^\d*\.?\d*$/.test(e.target.value))
//                             setFormData({ ...formData, paid: e.target.value });
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="row mb-2">
//                     <div className="col-6">
//                       <label className="form-label">
//                         Return Pure (g)
//                       </label>
//                     </div>
//                     <div className="col-6">
//                       <input
//                         type="text"
//                         className="form-control bg-light"
//                         value={returnPureCalculated}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </>
//               )}

//               <hr className="my-2" />

//               <div className="row mb-2">
//                 <div className="col-6">Opening (g)</div>
//                 <div className="col-6">
//                   <input className="form-control bg-light" value={formData.opening || "0.000"} readOnly />
//                 </div>
//               </div>
//               <div className="row mb-2">
//                 <div className="col-6">Current (g)</div>
//                 <div className="col-6">
//                   <input className="form-control bg-light" value={formData.current || "0.000"} readOnly />
//                 </div>
//               </div>
//               <div className="row mb-2">
//                 <div className="col-6">Closing (g)</div>
//                 <div className="col-6">
//                   <input className="form-control bg-light" value={formData.close || "0.000"} readOnly />
//                 </div>
//               </div>

//               <div className="d-flex justify-content-between mt-3">
//                 <button className="btn btn-secondary btn-sm" onClick={() => navigate("/retailers")}>
//                   Back
//                 </button>
//                 <button className="btn btn-danger btn-sm" onClick={handleClear}>
//                   Clear
//                 </button>
//                 <button className="btn btn-primary btn-sm" onClick={handlePrint} disabled={loading}>
//                   Print
//                 </button>
//                 <button className="btn btn-success btn-sm" onClick={handleSave} disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Modal */}
//       {showModal && (
//         <>
//           <div className="modal fade show" style={{ display: "block" }}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h6>Print Confirmation</h6>
//                   <button className="btn-close" onClick={() => setShowModal(false)}></button>
//                 </div>
//                 <div className="modal-body text-center">
//                   <p>Do you want to print the retailer bill?</p>
//                   <button className="btn btn-secondary mx-2" onClick={() => navigate("/retailers")}>
//                     Cancel
//                   </button>
//                   <button className="btn btn-primary" onClick={closeModal}>
//                     Print
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal-backdrop fade show"></div>
//         </>
//       )}
//     </>
//   );
// }

// export default AddRetailer;

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useToast } from "../Toast/ToastContext";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";

// function AddRetailer({ toggleSidebar }) {
//   const navigate = useNavigate();
//   const { retailerId } = useParams();
//   const toast = useToast();

//   const [loading, setLoading] = useState(false);
//   const [generateNumber, setGenerateNumber] = useState("");
//   const [productTypes, setProductTypes] = useState([]);
//   const [retailers, setRetailers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedRetailer, setSelectedRetailer] = useState(null);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const [userdata, setUserdata] = useState([]);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [selectedManager, setSelectedManager] = useState("");
//   const [selectedStaff, setSelectedStaff] = useState("");
//   const [staffList, setStaffList] = useState([]);
//   const [isManagerLocked, setIsManagerLocked] = useState(false);
//   const [isStaffLocked, setIsStaffLocked] = useState(false);

//   // New item state
//   const [newItem, setNewItem] = useState({
//     item: "",
//     category: "",
//     other_name: "",
//     type: "",
//     quantity: 1,
//     weight: "",
//     purity: "",
//     pure: "0.000",
//     total_amount: "0.000",
//     adjustment: "0.000",
//   });

//   const [adjustmentInput, setAdjustmentInput] = useState("");

//   const [todayRates, setTodayRates] = useState({
//     gold_pure_rate: 0,
//     silver_pure_rate: 0,
//     date: "",
//   });

//   const [returnPureCalculated, setReturnPureCalculated] = useState("0.000");

//   // Form data
//   const [formData, setFormData] = useState({
//     retailer_id: "",
//     retailer_date: new Date().toISOString().split("T")[0],
//     selected_retailer_id: "",
//     return_type: "",
//     enter_amount: "",
//     paid: "0",
//     pure: "0",
//     opening: "0.000",
//     current: "0.000",
//     close: "0.000",
//     total_pure: "0.000",
//     manager: "",
//     manager_name: "",
//     adjustment: "0.000",
//     staff: "",
//     items: [],
//   });

//   // Fetch today's rates
//   const fetchTodayRates = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/current`);
//       if (response.data.status && response.data.data) {
//         const rates = response.data.data;
//         setTodayRates({
//           gold_pure_rate: parseFloat(rates.gold_pure_percentage) || 0,
//           silver_pure_rate: parseFloat(rates.silver_pure_percentage) || 0,
//           date: rates.date,
//         });
//       }
//     } catch (error) {
//       console.error("Failed to fetch today's rates", error);
//     }
//   };

//   // Calculate pure for new item
//   useEffect(() => {
//     let pure = "0.000";
//     let total_amount = "0.000";

//     if (newItem.weight && newItem.purity && newItem.quantity) {
//       const weight = parseFloat(newItem.weight) || 0;
//       const purity = parseFloat(newItem.purity) || 0;
//       const quantity = parseFloat(newItem.quantity) || 1;

//       if (purity > 100) {
//         toast.error("Purity cannot exceed 100%", 3000, "topRight");
//         setNewItem((prev) => ({ ...prev, purity: "" }));
//         return;
//       }

//       const singlePure = (weight * purity) / 100;
//       let calculatedPure = quantity * singlePure;

//       const adjustment = parseFloat(newItem.adjustment) || 0;
//       calculatedPure += adjustment;

//       pure = calculatedPure.toFixed(3);
//       total_amount = (quantity * weight * (purity / 100)).toFixed(3);
//     }

//     setNewItem((prev) => ({ ...prev, pure, total_amount }));
//   }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment]);

//   // Total pure from all items
//   useEffect(() => {
//     const totalPure = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
//       .toFixed(3);

//     const totalAmount = formData.items
//       .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
//       .toFixed(3);

//     setFormData(prev => ({
//       ...prev,
//       total_pure: totalPure,
//       total_amount: totalAmount
//     }));
//   }, [formData.items]);

//   // MAIN CALCULATION – Current, Return Pure, Closing
//   useEffect(() => {
//     const opening = parseFloat(formData.opening) || 0;
//     const totalPure = parseFloat(formData.total_pure) || 0;

//     const current = (opening + totalPure).toFixed(3);

//     let returnedPureGrams = 0;
//     let validationError = false;

//     if (formData.return_type === "Pure") {
//       const pureInput = parseFloat(formData.pure) || 0;

//       if (pureInput > parseFloat(current)) {
//         toast.error("Return Pure cannot exceed Current", 3000, "topRight");
//         validationError = true;
//       } else {
//         returnedPureGrams = pureInput;
//       }
//     } else if (formData.return_type === "Amount") {
//       const paid = parseFloat(formData.paid) || 0;

//       if (paid > 0) {
//         const hasGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//         const hasSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

//         let rate = 0;
//         if (hasGold && !hasSilver) {
//           rate = todayRates.gold_pure_rate;
//         } else if (hasSilver && !hasGold) {
//           rate = todayRates.silver_pure_rate;
//         }

//         if (rate > 0) {
//           returnedPureGrams = paid / rate;

//           if (returnedPureGrams > parseFloat(current)) {
//             toast.error("Paid amount exceeds available current balance", 3000, "topRight");
//             validationError = true;
//             returnedPureGrams = 0;
//           } else {
//             setReturnPureCalculated(returnedPureGrams.toFixed(3));
//           }
//         }
//       } else {
//         setReturnPureCalculated("0.000");
//       }
//     }

//     const closing = Math.max(0, parseFloat(current) - returnedPureGrams).toFixed(3);

//     setFormData(prev => ({
//       ...prev,
//       current,
//       close: validationError ? prev.close : closing
//     }));
//   }, [
//     formData.opening,
//     formData.total_pure,
//     formData.pure,
//     formData.paid,
//     formData.return_type,
//     formData.items,
//     todayRates.gold_pure_rate,
//     todayRates.silver_pure_rate,
//     toast
//   ]);

//   // Amount mode: calculate enter_amount from total pure
//   useEffect(() => {
//     if (formData.return_type !== "Amount" || formData.items.length === 0) {
//       setFormData(prev => ({ ...prev, enter_amount: "" }));
//       return;
//     }

//     let goldPure = 0, silverPure = 0;
//     formData.items.forEach(item => {
//       const pure = parseFloat(item.pure) || 0;
//       if ((item.category === "Gold" || item.category === "Gold Coin")) goldPure += pure;
//       if ((item.category === "Silver" || item.category === "Silver Coin")) silverPure += pure;
//     });

//     const goldValue = goldPure * todayRates.gold_pure_rate;
//     const silverValue = silverPure * todayRates.silver_pure_rate;
//     const total = (goldValue + silverValue).toFixed(2);

//     setFormData(prev => ({ ...prev, enter_amount: total }));
//   }, [formData.items, formData.return_type, todayRates]);

//   // Reset type when item is Bar
//   useEffect(() => {
//     if (newItem.item === "Bar") {
//       setNewItem(prev => ({ ...prev, type: "", purity: "100" }));
//     }
//   }, [newItem.item]);

//   // Initial load
//   useEffect(() => {
//     toggleSidebar();
//     fetchInitialData();
//     fetchTodayRates();
//     fetchUserData();
//     fetchLoggedInUser();
//     if (retailerId) {
//       fetchRetailerDetailsData(retailerId);
//     }
//   }, [retailerId]);

//   const fetchInitialData = async () => {
//     try {
//       const idResponse = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
//       );
//       setGenerateNumber(idResponse.data.retailer_id || "");
//       if (!retailerId) {
//         setFormData((prev) => ({
//           ...prev,
//           retailer_id: idResponse.data.retailer_id || "",
//         }));
//       }

//       const retailerResponse = await axios.get(`${ApiUrl}/Api/retailer.php`);
//       setRetailers(retailerResponse.data?.data || []);

//       const typeResponse = await axios.get(`${ApiUrl}/Api/product_type.php`);
//       setProductTypes(typeResponse.data?.data || []);
//     } catch (error) {
//       console.error("Initialization error:", error);
//       toast.error("Failed to initialize form", 3000, "topRight");
//     }
//   };

//   const fetchRetailerDetailsData = async (id) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${ApiUrl}/Api/retailer_details.php?id=${id}`
//       );
//       const data = response.data.data[0];

//       if (data) {
//         setFormData({
//           retailer_id: data.retailer_id,
//           retailer_date: data.retailer_date,
//           selected_retailer_id: data.selected_retailer_id,
//           return_type: data.return_type || "",
//           enter_amount: data.enter_amount || "",
//           paid: data.paid || "0",
//           pure: data.pure || "0",
//           opening: parseFloat(data.opening || 0).toFixed(3),
//           current: parseFloat(data.current || 0).toFixed(3),
//           close: parseFloat(data.close || 0).toFixed(3),
//           total_pure: parseFloat(data.total_pure || 0).toFixed(3),
//           items: data.items.map((item, index) => ({
//             id: index + 1,
//             item: item.item,
//             other_name: item.other_name || "",
//             category: item.category,
//             type: item.type || "",
//             quantity: parseFloat(item.quantity) || 0,
//             weight: parseFloat(item.weight) || 0,
//             purity: parseFloat(item.percentage) || 0,
//             pure: parseFloat(item.pure) || 0,
//             total_amount: parseFloat(item.total_amount) || 0,
//             adjustment: parseFloat(item.adjustment) || 0,
//           })),
//           manager: data.manager || "",
//           manager_name: data.manager_name || "",
//           staff: data.staff || "",
//         });

//         const retailer = retailers.find(r => r.retailer_id === data.selected_retailer_id);
//         setSelectedRetailer(retailer);
//         setSearchTerm(
//           `${data.selected_retailer_id} - ${retailer?.name || ''}`
//         );
//         setGenerateNumber(data.retailer_id);
//       }
//     } catch (error) {
//       console.error("Error loading retailer details:", error);
//       toast.error("Failed to load retailer details data", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!selectedRetailer?.retailer_id || formData.items.length === 0) {
//       setFormData(prev => ({ ...prev, opening: "0.000" }));
//       return;
//     }

//     const fetchOpening = async () => {
//       try {
//         const res = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
//         const retailerDetails = res.data?.data || [];

//         const currentGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//         const currentSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

//         if (!currentGold && !currentSilver) {
//           setFormData(prev => ({ ...prev, opening: "0.000" }));
//           return;
//         }

//         const retailerRecords = retailerDetails
//           .filter(r => r.selected_retailer_id === selectedRetailer.retailer_id)
//           .sort((a, b) => new Date(b.retailer_date) - new Date(a.retailer_date));

//         if (retailerRecords.length === 0) {
//           setFormData(prev => ({ ...prev, opening: "0.000" }));
//           return;
//         }

//         const latestMatching = retailerRecords.find(record => {
//           const hasGold = record.items?.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//           const hasSilver = record.items?.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

//           if (currentGold && !currentSilver) return hasGold && !hasSilver;
//           if (currentSilver && !currentGold) return hasSilver && !hasGold;
//           if (currentGold && currentSilver) return hasGold && hasSilver;
//           return false;
//         });

//         const opening = latestMatching
//           ? parseFloat(latestMatching.close || 0).toFixed(3)
//           : "0.000";

//         setFormData(prev => ({ ...prev, opening }));
//       } catch (err) {
//         console.error("Error fetching opening balance", err);
//         setFormData(prev => ({ ...prev, opening: "0.000" }));
//       }
//     };

//     fetchOpening();
//   }, [selectedRetailer?.retailer_id, formData.items]);

//   const handleSelectRetailer = async (retailer) => {
//     setSelectedRetailer(retailer);
//     setSearchTerm(`${retailer.retailer_id} - ${retailer.name}`);
//     setFormData((prev) => ({
//       ...prev,
//       selected_retailer_id: retailer.retailer_id,
//       opening: "0.000",
//     }));
//     setShowDropdown(false);
//   };

//   const clearRetailer = () => {
//     setSelectedRetailer(null);
//     setSearchTerm("");
//     setFormData((prev) => ({
//       ...prev,
//       selected_retailer_id: "",
//       opening: "0.000",
//     }));
//   };

//   // Item functions
//   const validateItem = () => {
//     if (!newItem.item) return toast.error("Select item", 3000, "topRight"), false;
//     if (!newItem.category) return toast.error("Select category", 3000, "topRight"), false;
//     if (newItem.item !== "Bar" && !newItem.type)
//       return toast.error("Select type", 3000, "topRight"), false;
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0)
//       return toast.error("Valid quantity required", 3000, "topRight"), false;
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0)
//       return toast.error("Valid weight required", 3000, "topRight"), false;
//     if (!newItem.purity || parseFloat(newItem.purity) <= 0 || parseFloat(newItem.purity) > 100)
//       return toast.error("Valid purity (0-100%)", 3000, "topRight"), false;
//     if (newItem.item === "Others" && !newItem.other_name)
//       return toast.error("Enter name for Others", 3000, "topRight"), false;
//     return true;
//   };

//   const handleAddItem = () => {
//     if (!validateItem()) return;

//     const newItems = [
//       ...formData.items,
//       {
//         id: formData.items.length + 1,
//         item: newItem.item,
//         other_name: newItem.other_name,
//         category: newItem.category,
//         type: newItem.type,
//         quantity: parseFloat(newItem.quantity) || 1,
//         weight: parseFloat(newItem.weight) || 0,
//         purity: parseFloat(newItem.purity) || 0,
//         pure: parseFloat(newItem.pure) || 0,
//         total_amount: parseFloat(newItem.total_amount) || 0,
//         adjustment: parseFloat(newItem.adjustment) || 0,
//       },
//     ];

//     setFormData((prev) => ({ ...prev, items: newItems }));
//     resetNewItem();
//   };

//   const handleUpdateItem = () => {
//     if (!validateItem() || editingItemId === null) return;

//     const updated = formData.items.map((item) =>
//       item.id === editingItemId
//         ? {
//           ...item,
//           item: newItem.item,
//           other_name: newItem.other_name,
//           category: newItem.category,
//           type: newItem.type,
//           quantity: parseFloat(newItem.quantity) || 1,
//           weight: parseFloat(newItem.weight) || 0,
//           purity: parseFloat(newItem.purity) || 0,
//           pure: parseFloat(newItem.pure) || 0,
//           total_amount: parseFloat(newItem.total_amount) || 0,
//           adjustment: parseFloat(newItem.adjustment) || 0,
//         }
//         : item
//     );

//     setFormData((prev) => ({ ...prev, items: updated }));
//     resetNewItem();
//   };

//   const handleEditItem = (id) => {
//     const item = formData.items.find((i) => i.id === id);
//     if (item) {
//       setNewItem({
//         item: item.item,
//         category: item.category,
//         other_name: item.other_name || "",
//         type: item.type || "",
//         quantity: item.quantity.toString(),
//         weight: item.weight.toString(),
//         purity: item.purity.toString(),
//         pure: item.pure.toFixed(3),
//         total_amount: item.total_amount.toFixed(3),
//         adjustment: (item.adjustment || 0).toFixed(3),
//       });
//       setAdjustmentInput("");
//       setEditingItemId(id);
//     }
//   };

//   const handleRemoveItem = (id) => {
//     const filtered = formData.items
//       .filter((i) => i.id !== id)
//       .map((i, idx) => ({ ...i, id: idx + 1 }));
//     setFormData((prev) => ({ ...prev, items: filtered }));
//   };

//   const resetNewItem = () => {
//     setNewItem({
//       item: "",
//       category: "",
//       other_name: "",
//       type: "",
//       quantity: 1,
//       weight: "",
//       purity: "",
//       pure: "0.000",
//       total_amount: "0.000",
//       adjustment: "0.000",
//     });
//     setAdjustmentInput("");
//     setEditingItemId(null);
//   };

//   const validateForm = () => {
//     if (!formData.retailer_id) return toast.error("Retailer ID required", 3000, "topRight"), false;
//     if (!formData.retailer_date) return toast.error("Date required", 3000, "topRight"), false;
//     if (!formData.selected_retailer_id) return toast.error("Select retailer", 3000, "topRight"), false;
//     if (formData.items.length === 0) return toast.error("Add at least one item", 3000, "topRight"), false;
//     if (!formData.return_type) return toast.error("Select return type", 3000, "topRight"), false;

//     if (formData.return_type === "Pure") {
//       const pureReturn = parseFloat(formData.pure);
//       const current = parseFloat(formData.current);

//       if (!pureReturn || pureReturn <= 0) {
//         return toast.error("Enter valid pure return", 3000, "topRight"), false;
//       }

//       if (pureReturn > current) {
//         return toast.error("Return Pure cannot exceed Current", 3000, "topRight"), false;
//       }
//     }

//     if (formData.return_type === "Amount") {
//       const paid = parseFloat(formData.paid);
//       const current = parseFloat(formData.current);

//       if (!paid || paid <= 0) {
//         return toast.error("Enter valid paid amount", 3000, "topRight"), false;
//       }

//       const hasGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
//       const hasSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));
//       let rate = 0;

//       if (hasGold && !hasSilver) {
//         rate = todayRates.gold_pure_rate;
//       } else if (hasSilver && !hasGold) {
//         rate = todayRates.silver_pure_rate;
//       }

//       if (rate > 0) {
//         const paidInGrams = paid / rate;
//         if (paidInGrams > current) {
//           return toast.error("Paid amount exceeds available current balance", 3000, "topRight"), false;
//         }
//       }
//     }

//     if (!formData.manager) return toast.error("Select manager", 3000, "topRight"), false;
//     if (!formData.staff) return toast.error("Select staff", 3000, "topRight"), false;
//     return true;
//   };

//   const preparePayload = () => {
//     const payload = {
//       retailer_id: formData.retailer_id,
//       retailer_date: formData.retailer_date,
//       selected_retailer_id: formData.selected_retailer_id,
//       return_type: formData.return_type,
//       enter_amount: parseFloat(formData.enter_amount) || 0,
//       paid: parseFloat(formData.paid) || 0,
//       pure: parseFloat(formData.pure) || 0,
//       opening: parseFloat(formData.opening) || 0,
//       current: parseFloat(formData.current) || 0,
//       close: parseFloat(formData.close) || 0,
//       total_pure: parseFloat(formData.total_pure) || 0,
//       manager: formData.manager || "",
//       manager_name: formData.manager_name || "",
//       staff: formData.staff || "",
//       items: formData.items.map((i) => ({
//         category: i.category,
//         quantity: i.quantity,
//         item: i.item,
//         weight: i.weight,
//         type: i.type || "",
//         other_name: i.other_name || "",
//         percentage: i.purity,
//         pure: i.pure,
//         total_amount: i.total_amount,
//         adjustment: i.adjustment,
//         retailer_id: formData.retailer_id,
//       })),
//     };

//     if (formData.return_type === "Pure") {
//       payload.enter_amount = 0;
//       payload.paid = 0;
//     } else if (formData.return_type === "Amount") {
//       payload.pure = 0;
//     }

//     return payload;
//   };

//   const handleSave = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

//       if (res.status === 200 || res.status === 201) {
//         toast.success("Retailer details saved!", 3000, "topRight");
//         handleClear();
//         await fetchInitialData();
//         navigate("/retailers");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Save failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = async () => {
//     if (!validateForm()) return;
//     try {
//       setLoading(true);
//       const payload = preparePayload();
//       const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

//       if (res.status === 200 || res.status === 201) {
//         toast.success("Saved for print", 3000, "topRight");
//         setShowModal(true);
//       }
//     } catch (err) {
//       toast.error("Print failed", 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClear = () => {
//     setFormData({
//       retailer_id: generateNumber,
//       retailer_date: new Date().toISOString().split("T")[0],
//       selected_retailer_id: "",
//       return_type: "",
//       enter_amount: "",
//       paid: "0",
//       pure: "0",
//       opening: "0.000",
//       current: "0.000",
//       close: "0.000",
//       total_pure: "0.000",
//       items: [],
//       manager: "",
//       manager_name: "",
//       staff: "",
//     });
//     resetNewItem();
//     clearRetailer();
//     setSearchTerm("");
//     setReturnPureCalculated("0.000");
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     handleClear();
//     navigate(`/retailer-bill/${formData.retailer_id}`);
//   };

//   const fetchLoggedInUser = () => {
//     try {
//       const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
//       if (userInfo && userInfo.user_id) {
//         setLoggedInUser(userInfo);
//       }
//     } catch (error) {
//       console.error("Error reading logged-in user:", error);
//     }
//   };

//   const fetchUserData = async () => {
//     try {
//       const res = await axios.get(`${ApiUrl}/Api/user.php`);
//       const users = Array.isArray(res.data.data) ? res.data.data : [];
//       setUserdata(users);
//     } catch (err) {
//       console.error("Failed to fetch users", err);
//       toast.error("Failed to load staff data", 3000, 'topRight');
//     }
//   };

//   useEffect(() => {
//     if (!loggedInUser || userdata.length === 0) return;

//     const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
//     if (!currentUser) return;

//     if (currentUser.role === "Manager" || currentUser.role === "manager") {
//       setSelectedManager(currentUser.id.toString());
//       setIsManagerLocked(true);

//       const staff = userdata.filter(
//         u => u.manager_id === currentUser.user_id && (u.role === "Employee" || u.role === "employee")
//       );
//       setStaffList(staff);

//       setFormData(prev => ({
//         ...prev,
//         manager: currentUser.user_id,
//         manager_name: currentUser.name,
//       }));
//     }
//     else if (currentUser.role === "Employee" || currentUser.role === "employee") {
//       setSelectedStaff(currentUser.name);
//       setIsStaffLocked(true);

//       const manager = userdata.find(
//         u => u.user_id === currentUser.manager_id && (u.role === "Manager" || u.role === "manager")
//       );

//       if (manager) {
//         setSelectedManager(manager.id.toString());
//         setIsManagerLocked(true);

//         const staffUnderManager = userdata.filter(
//           u => u.manager_id === manager.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staffUnderManager);

//         setFormData(prev => ({
//           ...prev,
//           manager: manager.user_id,
//           manager_name: manager.name,
//           staff: currentUser.name,
//         }));
//       }
//     }
//   }, [loggedInUser, userdata]);

//   const handleManagerChange = (e) => {
//     if (isManagerLocked) return;
//     const managerId = e.target.value;
//     setSelectedManager(managerId);
//     setSelectedStaff("");
//     setStaffList([]);

//     if (managerId) {
//       const managerObj = userdata.find(u => u.id === parseInt(managerId));
//       if (managerObj) {
//         const staff = userdata.filter(
//           u => u.manager_id === managerObj.user_id && (u.role === "Employee" || u.role === "employee")
//         );
//         setStaffList(staff);

//         setFormData(prev => ({
//           ...prev,
//           manager: managerObj.user_id,
//           manager_name: managerObj.name,
//         }));
//       }
//     } else {
//       setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
//     }
//   };

//   const handleStaffChange = (e) => {
//     if (isStaffLocked) return;
//     const staffName = e.target.value;
//     setSelectedStaff(staffName);
//     setFormData(prev => ({ ...prev, staff: staffName }));
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid py-2">
//         {/* Header */}
//         <div className="row">
//           <div className="col-lg-3">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-6">
//                   <label className="form-label">Retailer ID</label>
//                   <input type="text" className="form-control" value={generateNumber} readOnly />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     value={formData.retailer_date}
//                     onChange={(e) =>
//                       setFormData((p) => ({ ...p, retailer_date: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Retailer Selection */}
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <div className="row g-3">
//                 <div className="col-md-12 position-relative">
//                   <label className="form-label">Select Retailer</label>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Search retailer..."
//                       value={searchTerm}
//                       onChange={(e) => {
//                         setSearchTerm(e.target.value);
//                         setShowDropdown(true);
//                       }}
//                       onFocus={() => setShowDropdown(true)}
//                     />
//                     {searchTerm && (
//                       <button className="btn btn-outline-secondary" onClick={clearRetailer}>
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                   </div>

//                   {showDropdown && retailers.length > 0 && (
//                     <div className="dropdown-menu show w-100">
//                       {retailers
//                         .filter(
//                           (r) =>
//                             r.retailer_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                             r.name.toLowerCase().includes(searchTerm.toLowerCase())
//                         )
//                         .map((r) => (
//                           <button
//                             key={r.retailer_id}
//                             className="dropdown-item"
//                             onClick={() => handleSelectRetailer(r)}
//                             type="button"
//                           >
//                             {r.retailer_id} - {r.name}
//                           </button>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row mt-3">
//           <div className="col-md-3">
//             <label className="form-label">
//               Manager <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedManager}
//               onChange={handleManagerChange}
//               disabled={isManagerLocked}
//             >
//               <option value="">Select Manager</option>
//               {userdata
//                 .filter(u => u.role === "Manager" || u.role === "manager")
//                 .map(manager => (
//                   <option key={manager.id} value={manager.id}>
//                     {manager.name}
//                   </option>
//                 ))}
//             </select>
//           </div>

//           <div className="col-md-3">
//             <label className="form-label">
//               Staff <span className="text-danger">*</span>
//             </label>
//             <select
//               className="form-select"
//               value={selectedStaff}
//               onChange={handleStaffChange}
//               disabled={isStaffLocked || !selectedManager}
//             >
//               <option value="">Select Staff</option>
//               {staffList.map(staff => (
//                 <option key={staff.id} value={staff.name}>
//                   {staff.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Item Entry */}
//         <div className="card mt-1 py-2">
//           <div className="row g-3">
//             <div className="col-md-2">
//               <label>Item</label>
//               <select
//                 className="form-select"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     item: e.target.value,
//                     type: e.target.value === "Bar" ? "" : newItem.type,
//                   })
//                 }
//               >
//                 <option value="">Select</option>
//                 <option value="Bar">Bar</option>
//                 <option value="Jewels">Jewels</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {newItem.item === "Others" && (
//               <div className="col-md-2">
//                 <label>Others Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={newItem.other_name}
//                   onChange={(e) => setNewItem({ ...newItem, other_name: e.target.value })}
//                 />
//               </div>
//             )}

//             <div className="col-md-2">
//               <label>Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 onChange={(e) => setNewItem({ ...newItem, category: e.target.value })}
//               >
//                 <option value="">Select</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label>Type</label>
//               <select
//                 className="form-select"
//                 value={newItem.type}
//                 onChange={(e) => setNewItem({ ...newItem, type: e.target.value })}
//                 disabled={newItem.item === "Bar"}
//               >
//                 <option value="">Select</option>
//                 {productTypes.map((t) => (
//                   <option key={t._id} value={t.type}>
//                     {t.type}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-1">
//               <label>Weight (g)</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   if (/^\d*\.?\d*$/.test(e.target.value))
//                     setNewItem({ ...newItem, weight: e.target.value });
//                 }}
//               />
//             </div>

//             <div className="col-md-2 position-relative">
//               <label>Adjustment</label>
//               <div className="input-group">
//                 <button
//                   className="btn btn-outline-danger btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem((p) => ({
//                         ...p,
//                         adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(3),
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-minus"></i>
//                 </button>

//                 <input
//                   type="text"
//                   className="form-control form-control-sm text-center"
//                   value={adjustmentInput}
//                   placeholder="0.000"
//                   onChange={(e) => {
//                     if (/^\d*\.?\d*$/.test(e.target.value)) setAdjustmentInput(e.target.value);
//                   }}
//                   onKeyPress={(e) => {
//                     if (e.key === "Enter") {
//                       const v = parseFloat(adjustmentInput) || 0;
//                       if (v > 0) {
//                         setNewItem((p) => ({
//                           ...p,
//                           adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
//                         }));
//                         setAdjustmentInput("");
//                       }
//                     }
//                   }}
//                 />

//                 <button
//                   className="btn btn-outline-success btn-sm"
//                   type="button"
//                   style={{ height: "30px" }}
//                   onClick={() => {
//                     const v = parseFloat(adjustmentInput) || 0;
//                     if (v > 0) {
//                       setNewItem((p) => ({
//                         ...p,
//                         adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
//                       }));
//                       setAdjustmentInput("");
//                     }
//                   }}
//                 >
//                   <i className="fa-solid fa-plus"></i>
//                 </button>

//                 {parseFloat(newItem.adjustment || 0) !== 0 && (
//                   <button
//                     className="btn btn-sm translate-middle-y me-1"
//                     style={{ zIndex: 10, background: "none", border: "none", position: "relative", top: "10px", right: "50px" }}
//                     onClick={() => setNewItem((p) => ({ ...p, adjustment: "0.000" }))}
//                   >
//                     <i className="fa-solid fa-xmark text-danger"></i>
//                   </button>
//                 )}
//               </div>
//             </div>

//             <div className="col-md-1">
//               <label>Purity (%)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 value={newItem.purity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
//                     const num = parseFloat(value);
//                     if (!value || num <= 100) {
//                       setNewItem({ ...newItem, purity: value });
//                     }
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label>Pure (g)</label>
//               <input type="text" className="form-control" value={newItem.pure} readOnly />
//             </div>

//             <div className="col-md-1 p-4">
//               {editingItemId === null ? (
//                 <button className="btn btn-success btn-sm" onClick={handleAddItem}>
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button className="btn btn-info btn-sm" onClick={handleUpdateItem}>
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Items Table + Summary */}
//         <div className="row mt-2">
//           <div className="col-lg-9">
//             <div className="card p-2">
//               <h6>Item List</h6>
//               <table className="table table-sm">
//                 <thead className="bg-light">
//                   <tr>
//                     <th>S.No</th>
//                     <th>Item</th>
//                     <th>Qty</th>
//                     <th>Cat</th>
//                     <th>Type</th>
//                     <th>Weight</th>
//                     <th>Purity</th>
//                     <th>Pure</th>
//                     <th>Adjustment</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {formData.items.map((item, i) => (
//                     <tr key={item.id}>
//                       <td>{i + 1}</td>
//                       <td>
//                         {item.item}
//                         {item.other_name && ` (${item.other_name})`}
//                       </td>
//                       <td>{item.quantity}</td>
//                       <td>{item.category}</td>
//                       <td>{item.type || "-"}</td>
//                       <td>{parseFloat(item.weight).toFixed(3)}</td>
//                       <td>{parseFloat(item.purity).toFixed(2)}%</td>
//                       <td>{parseFloat(item.pure).toFixed(3)}</td>
//                       <td className="text-start">
//                         <span className={item.adjustment > 0 ? "text-success" : item.adjustment < 0 ? "text-danger" : ""}>
//                           {item.adjustment > 0 ? "+" : ""}
//                           {parseFloat(item.adjustment || 0).toFixed(3)}
//                         </span>
//                       </td>
//                       <td>
//                         <button className="btn btn-sm btn-light" onClick={() => handleEditItem(item.id)}>
//                           <i className="fa-solid fa-pen-to-square text-primary"></i>
//                         </button>
//                         <button className="btn btn-sm btn-light" onClick={() => handleRemoveItem(item.id)}>
//                           <i className="fa-solid fa-trash text-danger"></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                   {formData.items.length === 0 && (
//                     <tr><td colSpan="10" className="text-center">No items</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Summary */}
//           <div className="col-lg-3">
//             <div className="card p-3">
//               <div className="row mb-2">
//                 <div className="col-6">Total Pure (g)</div>
//                 <div className="col-6">
//                   <input type="text" className="form-control" value={formData.total_pure || "0.000"} readOnly />
//                 </div>
//               </div>

//               <div className="row mb-2">
//                 <div className="col-6">Return Type</div>
//                 <div className="col-6">
//                   <select
//                     className="form-select"
//                     value={formData.return_type}
//                     onChange={(e) => {
//                       const newReturnType = e.target.value;
//                       setFormData({
//                         ...formData,
//                         return_type: newReturnType,
//                         pure: "",
//                         paid: "",
//                         enter_amount: "",
//                       });
//                       setReturnPureCalculated("0.000");
//                     }}
//                   >
//                     <option value="">Select</option>
//                     <option value="Pure">Pure</option>
//                     <option value="Amount">Amount</option>
//                   </select>
//                 </div>
//               </div>

//               {formData.return_type === "Pure" && (
//                 <div className="row mb-2">
//                   <div className="col-6">
//                     <label className="form-label">Return Pure (g)</label>
//                   </div>
//                   <div className="col-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="0.000"
//                       value={formData.pure}
//                       onChange={(e) => {
//                         if (/^\d*\.?\d*$/.test(e.target.value))
//                           setFormData({ ...formData, pure: e.target.value });
//                       }}
//                     />
//                   </div>
//                 </div>
//               )}

//               {formData.return_type === "Amount" && (
//                 <>
//                   <div className="row mb-2">
//                     <div className="col-6">
//                       <label className="form-label">Paid (₹)</label>
//                     </div>
//                     <div className="col-6">
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="0.00"
//                         value={formData.paid}
//                         onChange={(e) => {
//                           if (/^\d*\.?\d*$/.test(e.target.value))
//                             setFormData({ ...formData, paid: e.target.value });
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="row mb-2">
//                     <div className="col-6">
//                       <label className="form-label">Return Pure (g)</label>
//                     </div>
//                     <div className="col-6">
//                       <input
//                         type="text"
//                         className="form-control bg-light"
//                         value={returnPureCalculated}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </>
//               )}

//               <hr className="my-2" />

//               <div className="row mb-2">
//                 <div className="col-6">Opening (g)</div>
//                 <div className="col-6">
//                   <input className="form-control bg-light" value={formData.opening || "0.000"} readOnly />
//                 </div>
//               </div>
//               <div className="row mb-2">
//                 <div className="col-6">Current (g)</div>
//                 <div className="col-6">
//                   <input className="form-control bg-light" value={formData.current || "0.000"} readOnly />
//                 </div>
//               </div>
//               <div className="row mb-2">
//                 <div className="col-6">Closing (g)</div>
//                 <div className="col-6">
//                   <input className="form-control bg-light" value={formData.close || "0.000"} readOnly />
//                 </div>
//               </div>

//               <div className="d-flex justify-content-between mt-3">
//                 <button className="btn btn-secondary btn-sm" onClick={() => navigate("/retailers")}>
//                   Back
//                 </button>
//                 <button className="btn btn-danger btn-sm" onClick={handleClear}>
//                   Clear
//                 </button>
//                 <button className="btn btn-primary btn-sm" onClick={handlePrint} disabled={loading}>
//                   Print
//                 </button>
//                 <button className="btn btn-success btn-sm" onClick={handleSave} disabled={loading}>
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Modal */}
//       {showModal && (
//         <>
//           <div className="modal fade show" style={{ display: "block" }}>
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h6>Print Confirmation</h6>
//                   <button className="btn-close" onClick={() => setShowModal(false)}></button>
//                 </div>
//                 <div className="modal-body text-center">
//                   <p>Do you want to print the retailer bill?</p>
//                   <button className="btn btn-secondary mx-2" onClick={() => navigate("/retailers")}>
//                     Cancel
//                   </button>
//                   <button className="btn btn-primary" onClick={closeModal}>
//                     Print
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal-backdrop fade show"></div>
//         </>
//       )}
//     </>
//   );
// }

// export default AddRetailer;



import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../Toast/ToastContext";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";

function AddRetailer({ toggleSidebar }) {
  const navigate = useNavigate();
  const { retailerId } = useParams();
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [generateNumber, setGenerateNumber] = useState("");
  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [userdata, setUserdata] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [isManagerLocked, setIsManagerLocked] = useState(false);
  const [isStaffLocked, setIsStaffLocked] = useState(false);
  const [showAddRetailerModal, setShowAddRetailerModal] = useState(false);
  const [newRetailerId, setNewRetailerId] = useState("");
  const [retailerSearchTerm, setRetailerSearchTerm] = useState("");
  const [showRetailerDropdown, setShowRetailerDropdown] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
const [isTranslating, setIsTranslating] = useState(false);
const [productFormErrors, setProductFormErrors] = useState({});
const [productAddData, setProductAddData] = useState({
    item_code: "",
    item_name: "",
    item_name_english: "",
    item_name_tamil: "",
    category: "",
    type: "",
    pure_percent: "",
    status: "Active",
    image: null,
});
  const [addData, setAddData] = useState({
    name: "",
    mobile: "",
    address: "",
    status: "Active"
  });
  const [formErrors, setFormErrors] = useState({});

  // New item state
const [newItem, setNewItem] = useState({
  item: "",
  category: "",
  other_name: "",
  type: "",
  item_name_english: "",  // Add this
  item_name_tamil: "",     // Add this
  quantity: 1,
  weight: "",
  purity: "",
  pure: "0.000",
  total_amount: "0.000",
  adjustment: "0.000",
});

const translateToTamil = async (englishText) => {
    if (!englishText || englishText.trim().length < 2) return "";

    setIsTranslating(true);

    const apis = [
        async () => {
            const encoded = encodeURIComponent(englishText.trim());
            const res = await fetch(
                `https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`,
            );
            const data = await res.json();
            const translated = data?.responseData?.translatedText;
            if (translated && translated.toLowerCase() !== englishText.toLowerCase()) {
                return translated;
            }
            return null;
        },
        async () => {
            const encoded = encodeURIComponent(englishText.trim());
            const res = await fetch(`https://lingva.ml/api/v1/en/ta/${encoded}`);
            if (res.ok) {
                const data = await res.json();
                if (data.translation && data.translation !== englishText) {
                    return data.translation;
                }
            }
            return null;
        },
        async () => {
            const res = await fetch("https://libretranslate.com/translate", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    q: englishText.trim(),
                    source: "en",
                    target: "ta",
                    format: "text",
                }),
            });
            if (res.ok) {
                const data = await res.json();
                if (data.translatedText) {
                    return data.translatedText;
                }
            }
            return null;
        },
    ];

    for (const api of apis) {
        try {
            const result = await api();
            if (result) {
                setIsTranslating(false);
                return result;
            }
        } catch (error) {
            console.warn("Translation API failed:", error);
            continue;
        }
    }

    setIsTranslating(false);
    return "";
};

const fetchProductItemCode = async () => {
    try {
        const response = await axios.get(`${ApiUrl}/Api/product.php/generate-item-code`);
        setProductAddData((prev) => ({
            ...prev,
            item_code: response.data?.item_code || "",
        }));
    } catch (error) {
        console.error("Error fetching product item code:", error.message);
        toast.error("Failed to generate product code", 3000, "topRight");
    }
};

const openProductModal = () => {
    fetchProductItemCode();
    setProductAddData({
        item_code: "",
        item_name: "",
        item_name_english: "",
        item_name_tamil: "",
        category: "",
        type: "",
        pure_percent: "",
        status: "Active",
        image: null,
    });
    setProductFormErrors({});
    setShowProductModal(true);
};

const closeProductModal = () => {
    setShowProductModal(false);
    setProductAddData({
        item_code: "",
        item_name: "",
        item_name_english: "",
        item_name_tamil: "",
        category: "",
        type: "",
        pure_percent: "",
        status: "Active",
        image: null,
    });
    setProductFormErrors({});
};

const handleProductSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    if (!productAddData.item_name_english) errors.item_name = "Item name is required";
    if (!productAddData.category) errors.category = "Category is required";
    if (!productAddData.pure_percent) errors.pure_percent = "Purity percentage is required";
    if (!productAddData.status) errors.status = "Status is required";

    if (Object.keys(errors).length > 0) {
        setProductFormErrors(errors);
        return;
    }

    try {
        setLoading(true);
        const formData = new FormData();

        let finalTamilName = productAddData.item_name_tamil;
        if (!finalTamilName && productAddData.item_name_english) {
            finalTamilName = await translateToTamil(productAddData.item_name_english);
        }

        formData.append("item_code", productAddData.item_code || "");
        formData.append("item_name", productAddData.item_name_english || "");
        formData.append("item_name_english", productAddData.item_name_english || "");
        formData.append("item_name_tamil", finalTamilName || "");
        formData.append("category", productAddData.category || "");
        formData.append("type", productAddData.type || "");
        formData.append("pure_percent", productAddData.pure_percent || "");
        formData.append("status", productAddData.status || "");
        formData.append("created_by", "retailer");

        if (productAddData.image) {
            formData.append("image", productAddData.image);
        }

        const response = await axios.post(`${ApiUrl}/Api/product.php`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });

        if (response.data?.status === true || response.status === 200 || response.status === 201) {
            toast.success("Product added successfully!", 3000, "topRight");
            closeProductModal();
            // Refresh products list
            const productResponse = await axios.get(`${ApiUrl}/Api/product.php`);
            setProducts(productResponse.data?.data || []);
        } else {
            throw new Error(response.data?.message || "Failed to add product");
        }
    } catch (error) {
        console.error("Error adding product:", error);
        toast.error(error.response?.data?.message || "Failed to add product", 3000, "topRight");
    } finally {
        setLoading(false);
    }
};

  const [adjustmentInput, setAdjustmentInput] = useState("");

  const [todayRates, setTodayRates] = useState({
    gold_pure_rate: 0,
    silver_pure_rate: 0,
    date: "",
  });

  const [returnPureCalculated, setReturnPureCalculated] = useState("0.000");

  // Form data
  const [formData, setFormData] = useState({
    retailer_id: "",
    retailer_date: new Date().toISOString().split("T")[0],
    supplier_id: "",
    retailer_name: "",
    retailer_mobile: "",
    retailer_address: "",
    return_type: "",
    enter_amount: "",
    paid: "0",
    pure: "0",
    opening: "0.000",
    current: "0.000",
    close: "0.000",
    total_pure: "0.000",
    manager: "",
    manager_name: "",
    adjustment: "0.000",
    staff: "",
    items: [],
  });

  // Fetch today's rates
  const fetchTodayRates = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/current`);
      if (response.data.status && response.data.data) {
        const rates = response.data.data;
        setTodayRates({
          gold_pure_rate: parseFloat(rates.gold_pure_percentage) || 0,
          silver_pure_rate: parseFloat(rates.silver_pure_percentage) || 0,
          date: rates.date,
        });
      }
    } catch (error) {
      console.error("Failed to fetch today's rates", error);
    }
  };

  // Calculate pure for new item
  useEffect(() => {
    let pure = "0.000";
    let total_amount = "0.000";

    if (newItem.weight && newItem.purity && newItem.quantity) {
      const weight = parseFloat(newItem.weight) || 0;
      const purity = parseFloat(newItem.purity) || 0;
      const quantity = parseFloat(newItem.quantity) || 1;

      if (purity > 100) {
        toast.error("Purity cannot exceed 100%", 3000, "topRight");
        setNewItem((prev) => ({ ...prev, purity: "" }));
        return;
      }

      const singlePure = (weight * purity) / 100;
      let calculatedPure = quantity * singlePure;

      const adjustment = parseFloat(newItem.adjustment) || 0;
      calculatedPure += adjustment;

      pure = calculatedPure.toFixed(3);
      total_amount = (quantity * weight * (purity / 100)).toFixed(3);
    }

    setNewItem((prev) => ({ ...prev, pure, total_amount }));
  }, [newItem.weight, newItem.purity, newItem.quantity, newItem.adjustment]);

  // Total pure from all items
  useEffect(() => {
    const totalPure = formData.items
      .reduce((sum, item) => sum + parseFloat(item.pure || 0), 0)
      .toFixed(3);

    const totalAmount = formData.items
      .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
      .toFixed(3);

    setFormData(prev => ({
      ...prev,
      total_pure: totalPure,
      total_amount: totalAmount
    }));
  }, [formData.items]);

  // Filter products based on selected category
useEffect(() => {
  if (newItem.category) {
    const filtered = products.filter(product => 
      product.category === newItem.category
    );
    setFilteredProducts(filtered);
  } else {
    setFilteredProducts([]);
  }
}, [newItem.category, products]);

  // MAIN CALCULATION – Current, Return Pure, Closing
  useEffect(() => {
    const opening = parseFloat(formData.opening) || 0;
    const totalPure = parseFloat(formData.total_pure) || 0;

    const current = (opening + totalPure).toFixed(3);

    let returnedPureGrams = 0;
    let validationError = false;

    if (formData.return_type === "Pure") {
      const pureInput = parseFloat(formData.pure) || 0;

      if (pureInput > parseFloat(current)) {
        toast.error("Return Pure cannot exceed Current", 3000, "topRight");
        validationError = true;
      } else {
        returnedPureGrams = pureInput;
      }
    } else if (formData.return_type === "Amount") {
      const paid = parseFloat(formData.paid) || 0;

      if (paid > 0) {
        const hasGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
        const hasSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

        let rate = 0;
        if (hasGold && !hasSilver) {
          rate = todayRates.gold_pure_rate;
        } else if (hasSilver && !hasGold) {
          rate = todayRates.silver_pure_rate;
        }

        if (rate > 0) {
          returnedPureGrams = paid / rate;

          if (returnedPureGrams > parseFloat(current)) {
            toast.error("Paid amount exceeds available current balance", 3000, "topRight");
            validationError = true;
            returnedPureGrams = 0;
          } else {
            setReturnPureCalculated(returnedPureGrams.toFixed(3));
          }
        }
      } else {
        setReturnPureCalculated("0.000");
      }
    }

    const closing = Math.max(0, parseFloat(current) - returnedPureGrams).toFixed(3);

    setFormData(prev => ({
      ...prev,
      current,
      close: validationError ? prev.close : closing
    }));
  }, [
    formData.opening,
    formData.total_pure,
    formData.pure,
    formData.paid,
    formData.return_type,
    formData.items,
    todayRates.gold_pure_rate,
    todayRates.silver_pure_rate,
    toast
  ]);

  // Amount mode: calculate enter_amount from total pure
  useEffect(() => {
    if (formData.return_type !== "Amount" || formData.items.length === 0) {
      setFormData(prev => ({ ...prev, enter_amount: "" }));
      return;
    }

    let goldPure = 0, silverPure = 0;
    formData.items.forEach(item => {
      const pure = parseFloat(item.pure) || 0;
      if ((item.category === "Gold" || item.category === "Gold Coin")) goldPure += pure;
      if ((item.category === "Silver" || item.category === "Silver Coin")) silverPure += pure;
    });

    const goldValue = goldPure * todayRates.gold_pure_rate;
    const silverValue = silverPure * todayRates.silver_pure_rate;
    const total = (goldValue + silverValue).toFixed(2);

    setFormData(prev => ({ ...prev, enter_amount: total }));
  }, [formData.items, formData.return_type, todayRates]);

  // Reset type when item is Bar
  useEffect(() => {
    if (newItem.item === "Bar") {
      setNewItem(prev => ({ ...prev, type: "", purity: "100" }));
    }
  }, [newItem.item]);

  // Initial load
  useEffect(() => {
    toggleSidebar();
    fetchInitialData();
    fetchTodayRates();
    fetchUserData();
    fetchLoggedInUser();
    if (retailerId) {
      fetchRetailerDetailsData(retailerId);
    }
  }, [retailerId]);

const fetchInitialData = async () => {
  try {
    const idResponse = await axios.get(
      `${ApiUrl}/Api/retailer_details.php/generate-retailer-code`
    );
    setGenerateNumber(idResponse.data.retailer_id || "");
    if (!retailerId) {
      setFormData((prev) => ({
        ...prev,
        retailer_id: idResponse.data.retailer_id || "",
      }));
    }

    const retailerResponse = await axios.get(`${ApiUrl}/Api/retailer.php`);
    setRetailers(retailerResponse.data?.data || []);

    // Fetch products
    const productResponse = await axios.get(`${ApiUrl}/Api/product.php`);
    console.log("Products response:", productResponse.data);
    console.log("Products data:", productResponse.data?.data);
    setProducts(productResponse.data?.data || []);
    
  } catch (error) {
    console.error("Initialization error:", error);
    toast.error("Failed to initialize form", 3000, "topRight");
  }
};

  const fetchRetailers = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/retailer.php`);
      setRetailers(response.data?.data || []);
    } catch (error) {
      console.error("Failed to fetch retailers", error);
    }
  };

  const validateRetailerForm = (data) => {
    const errors = {};
    if (!data.name) errors.name = "Name is required";
    if (!data.mobile) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(data.mobile)) {
      errors.mobile = "Mobile number must be 10 digits";
    }
    if (!data.address) errors.address = "Address is required";
    if (!data.status) errors.status = "Status is required";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddRetailerSubmit = async () => {
    if (!validateRetailerForm(addData)) return;

    try {
      setLoading(true);
      const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");
      const payload = {
        retailer_id: newRetailerId,
        ...addData,
        created_by: "admin",
        created_date: currentDateTime,
        updated_by: "admin",
        updated_date: currentDateTime,
      };

      const addResponse = await axios.post(`${ApiUrl}/Api/retailer.php`, payload, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (addResponse.data?.status === false) {
        throw new Error(addResponse.data?.message || "Failed to add retailer");
      }

      toast.success("Retailer added successfully!", 3000, "topRight");

      // Refresh retailers list
      await fetchRetailers();

      // Auto-select the newly added retailer
      const newRetailer = {
        retailer_id: newRetailerId,
        ...addData
      };
      handleSelectRetailer(newRetailer);

      closeAddRetailerModal();
    } catch (error) {
      console.error("Error adding retailer:", error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to add retailer";
      toast.error(errorMessage, 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };
  const openAddRetailerModal = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/retailer.php/generate-retailer-code`);
      const newId = response.data?.retailer_id || "";
      setNewRetailerId(newId);
      setAddData(prev => ({ ...prev, retailer_id: newId }));
      setShowAddRetailerModal(true);
    } catch (error) {
      toast.error("Failed to generate retailer ID", 3000, "topRight");
    }
  };

  const closeAddRetailerModal = () => {
    setShowAddRetailerModal(false);
    setAddData({
      name: "",
      mobile: "",
      address: "",
      status: "Active"
    });
    setNewRetailerId("");
    setFormErrors({});
  };

  const fetchRetailerDetailsData = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${ApiUrl}/Api/retailer_details.php?id=${id}`
      );
      const data = response.data.data[0];

      if (data) {
        setFormData({
          retailer_id: data.retailer_id,
          retailer_date: data.retailer_date,
          supplier_id: data.supplier_id,
          retailer_name: data.retailer_name || "",
          retailer_mobile: data.retailer_mobile || "",
          retailer_address: data.retailer_address || "",
          return_type: data.return_type || "",
          enter_amount: data.enter_amount || "",
          paid: data.paid || "0",
          pure: data.pure || "0",
          opening: parseFloat(data.opening || 0).toFixed(3),
          current: parseFloat(data.current || 0).toFixed(3),
          close: parseFloat(data.close || 0).toFixed(3),
          total_pure: parseFloat(data.total_pure || 0).toFixed(3),
          items: data.items.map((item, index) => ({
            id: index + 1,
            item: item.item,
            other_name: item.other_name || "",
            category: item.category,
            type: item.type || "",
            quantity: parseFloat(item.quantity) || 0,
            weight: parseFloat(item.weight) || 0,
            purity: parseFloat(item.percentage) || 0,
            pure: parseFloat(item.pure) || 0,
            total_amount: parseFloat(item.total_amount) || 0,
            adjustment: parseFloat(item.adjustment) || 0,
          })),
          manager: data.manager || "",
          manager_name: data.manager_name || "",
          staff: data.staff || "",
        });

        const retailer = retailers.find(r => r.retailer_id === data.supplier_id);
        setSelectedRetailer(retailer);
        setSearchTerm(
          `${data.supplier_id} - ${retailer?.name || ''}`
        );
        setGenerateNumber(data.retailer_id);
      }
    } catch (error) {
      console.error("Error loading retailer details:", error);
      toast.error("Failed to load retailer details data", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedRetailer?.retailer_id || formData.items.length === 0) {
      setFormData(prev => ({ ...prev, opening: "0.000" }));
      return;
    }

    const fetchOpening = async () => {
      try {
        const res = await axios.get(`${ApiUrl}/Api/retailer_details.php`);
        const retailerDetails = res.data?.data || [];

        const currentGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
        const currentSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

        if (!currentGold && !currentSilver) {
          setFormData(prev => ({ ...prev, opening: "0.000" }));
          return;
        }

        const retailerRecords = retailerDetails
          .filter(r => r.supplier_id === selectedRetailer.retailer_id)
          .sort((a, b) => new Date(b.retailer_date) - new Date(a.retailer_date));

        if (retailerRecords.length === 0) {
          setFormData(prev => ({ ...prev, opening: "0.000" }));
          return;
        }

        const latestMatching = retailerRecords.find(record => {
          const hasGold = record.items?.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
          const hasSilver = record.items?.some(i => (i.category === "Silver" || i.category === "Silver Coin"));

          if (currentGold && !currentSilver) return hasGold && !hasSilver;
          if (currentSilver && !currentGold) return hasSilver && !hasGold;
          if (currentGold && currentSilver) return hasGold && hasSilver;
          return false;
        });

        const opening = latestMatching
          ? parseFloat(latestMatching.close || 0).toFixed(3)
          : "0.000";

        setFormData(prev => ({ ...prev, opening }));
      } catch (err) {
        console.error("Error fetching opening balance", err);
        setFormData(prev => ({ ...prev, opening: "0.000" }));
      }
    };

    fetchOpening();
  }, [selectedRetailer?.retailer_id, formData.items]);

  const handleSelectRetailer = async (retailer) => {
    setSelectedRetailer(retailer);
    setRetailerSearchTerm(`${retailer.retailer_id} - ${retailer.name}`);
    setShowRetailerDropdown(false);
    setSelectedRetailer(retailer);
    setSearchTerm(`${retailer.retailer_id} - ${retailer.name}`);
    setFormData((prev) => ({
      ...prev,
      supplier_id: retailer.retailer_id,
      retailer_name: retailer.name || "",
      retailer_mobile: retailer.mobile || "",
      retailer_address: retailer.address || "",
      opening: "0.000",
    }));
    setShowDropdown(false);
  };

  const clearRetailer = () => {
    setSelectedRetailer(null);
    setRetailerSearchTerm("");
    setSearchTerm("");
    setFormData((prev) => ({
      ...prev,
      supplier_id: "",
      retailer_name: "",
      retailer_mobile: "",
      retailer_address: "",
      opening: "0.000",
    }));
  };

  // Item functions
  const validateItem = () => {
    if (!newItem.item) return toast.error("Select item", 3000, "topRight"), false;
    if (!newItem.category) return toast.error("Select category", 3000, "topRight"), false;
    if (newItem.item !== "Bar" && !newItem.type)
      return toast.error("Select type", 3000, "topRight"), false;
    if (!newItem.quantity || parseFloat(newItem.quantity) <= 0)
      return toast.error("Valid quantity required", 3000, "topRight"), false;
    if (!newItem.weight || parseFloat(newItem.weight) <= 0)
      return toast.error("Valid weight required", 3000, "topRight"), false;
    if (!newItem.purity || parseFloat(newItem.purity) <= 0 || parseFloat(newItem.purity) > 100)
      return toast.error("Valid purity (0-100%)", 3000, "topRight"), false;
    if (newItem.item === "Others" && !newItem.other_name)
      return toast.error("Enter name for Others", 3000, "topRight"), false;
    return true;
  };

const handleAddItem = () => {
  if (!validateItem()) return;

  const newItems = [
    ...formData.items,
    {
      id: formData.items.length + 1,
      item: newItem.item,
      other_name: newItem.other_name,
      item_name_english: newItem.item_name_english || newItem.item, // Add this
      item_name_tamil: newItem.item_name_tamil || "",               // Add this
      category: newItem.category,
      type: newItem.type,
      quantity: parseFloat(newItem.quantity) || 1,
      weight: parseFloat(newItem.weight) || 0,
      purity: parseFloat(newItem.purity) || 0,
      pure: parseFloat(newItem.pure) || 0,
      total_amount: parseFloat(newItem.total_amount) || 0,
      adjustment: parseFloat(newItem.adjustment) || 0,
    },
  ];

  setFormData((prev) => ({ ...prev, items: newItems }));
  resetNewItem();
};

const handleUpdateItem = () => {
  if (!validateItem() || editingItemId === null) return;

  const updated = formData.items.map((item) =>
    item.id === editingItemId
      ? {
          ...item,
          item: newItem.item,
          other_name: newItem.other_name,
          item_name_english: newItem.item_name_english || newItem.item, // Add this
          item_name_tamil: newItem.item_name_tamil || "",               // Add this
          category: newItem.category,
          type: newItem.type,
          quantity: parseFloat(newItem.quantity) || 1,
          weight: parseFloat(newItem.weight) || 0,
          purity: parseFloat(newItem.purity) || 0,
          pure: parseFloat(newItem.pure) || 0,
          total_amount: parseFloat(newItem.total_amount) || 0,
          adjustment: parseFloat(newItem.adjustment) || 0,
        }
      : item
  );

  setFormData((prev) => ({ ...prev, items: updated }));
  resetNewItem();
};
const handleEditItem = (id) => {
  const item = formData.items.find((i) => i.id === id);
  if (item) {
    setNewItem({
      item: item.item,
      category: item.category,
      other_name: item.other_name || "",
      type: item.type || "",
      item_name_english: item.item_name_english || item.item, // Add this
      item_name_tamil: item.item_name_tamil || "",            // Add this
      quantity: item.quantity.toString(),
      weight: item.weight.toString(),
      purity: item.purity.toString(),
      pure: item.pure.toFixed(3),
      total_amount: item.total_amount.toFixed(3),
      adjustment: (item.adjustment || 0).toFixed(3),
    });
    setAdjustmentInput("");
    setEditingItemId(id);
  }
};

  const handleRemoveItem = (id) => {
    const filtered = formData.items
      .filter((i) => i.id !== id)
      .map((i, idx) => ({ ...i, id: idx + 1 }));
    setFormData((prev) => ({ ...prev, items: filtered }));
  };

const resetNewItem = () => {
  setNewItem({
    item: "",
    category: "",
    other_name: "",
    type: "",
    item_name_english: "",  // Add this
    item_name_tamil: "",     // Add this
    quantity: 1,
    weight: "",
    purity: "",
    pure: "0.000",
    total_amount: "0.000",
    adjustment: "0.000",
  });
  setAdjustmentInput("");
  setEditingItemId(null);
};

  const validateForm = () => {
    if (!formData.retailer_id) return toast.error("Retailer ID required", 3000, "topRight"), false;
    if (!formData.retailer_date) return toast.error("Date required", 3000, "topRight"), false;
    if (!formData.supplier_id) return toast.error("Select retailer", 3000, "topRight"), false;
    if (formData.items.length === 0) return toast.error("Add at least one item", 3000, "topRight"), false;
    if (!formData.return_type) return toast.error("Select return type", 3000, "topRight"), false;

    if (formData.return_type === "Pure") {
      const pureReturn = parseFloat(formData.pure);
      const current = parseFloat(formData.current);

      if (!pureReturn || pureReturn <= 0) {
        return toast.error("Enter valid pure return", 3000, "topRight"), false;
      }

      if (pureReturn > current) {
        return toast.error("Return Pure cannot exceed Current", 3000, "topRight"), false;
      }
    }

    if (formData.return_type === "Amount") {
      const paid = parseFloat(formData.paid);
      const current = parseFloat(formData.current);

      if (!paid || paid <= 0) {
        return toast.error("Enter valid paid amount", 3000, "topRight"), false;
      }

      const hasGold = formData.items.some(i => (i.category === "Gold" || i.category === "Gold Coin"));
      const hasSilver = formData.items.some(i => (i.category === "Silver" || i.category === "Silver Coin"));
      let rate = 0;

      if (hasGold && !hasSilver) {
        rate = todayRates.gold_pure_rate;
      } else if (hasSilver && !hasGold) {
        rate = todayRates.silver_pure_rate;
      }

      if (rate > 0) {
        const paidInGrams = paid / rate;
        if (paidInGrams > current) {
          return toast.error("Paid amount exceeds available current balance", 3000, "topRight"), false;
        }
      }
    }

    if (!formData.manager) return toast.error("Select manager", 3000, "topRight"), false;
    const currentRole = JSON.parse(localStorage.getItem("user") || "{}").role || "";
    const isAdminRole = currentRole === "Admin" || currentRole === "admin";
    if (!isAdminRole && !formData.staff) return toast.error("Select staff", 3000, "topRight"), false;
    return true;
  };

  const preparePayload = () => {
    const payload = {
      retailer_id: formData.retailer_id,
      retailer_date: formData.retailer_date,
      supplier_id: formData.supplier_id,
      return_type: formData.return_type,
      enter_amount: parseFloat(formData.enter_amount) || 0,
      paid: parseFloat(formData.paid) || 0,
      pure: parseFloat(formData.pure) || 0,
      opening: parseFloat(formData.opening) || 0,
      current: parseFloat(formData.current) || 0,
      close: parseFloat(formData.close) || 0,
      total_pure: parseFloat(formData.total_pure) || 0,
      manager: formData.manager || "",
      manager_name: formData.manager_name || "",
      staff: formData.staff || "",
      items: formData.items.map((i) => ({
        category: i.category,
        quantity: i.quantity,
        item: i.item,
        weight: i.weight,
        type: i.type || "",
        other_name: i.other_name || "",
        percentage: i.purity,
        pure: i.pure,
        total_amount: i.total_amount,
        adjustment: i.adjustment,
        retailer_id: formData.retailer_id,
      })),
    };

    if (formData.return_type === "Pure") {
      payload.enter_amount = 0;
      payload.paid = 0;
    } else if (formData.return_type === "Amount") {
      payload.pure = 0;
    }

    return payload;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      const payload = preparePayload();
      const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

      if (res.status === 200 || res.status === 201) {
        toast.success("Retailer details saved!", 3000, "topRight");
        handleClear();
        await fetchInitialData();
        navigate("/retailers");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Save failed", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      const payload = preparePayload();
      const res = await axios.post(`${ApiUrl}/Api/retailer_details.php`, payload);

      if (res.status === 200 || res.status === 201) {
        toast.success("Saved for print", 3000, "topRight");
        setShowModal(true);
      }
    } catch (err) {
      toast.error("Print failed", 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      retailer_id: generateNumber,
      retailer_date: new Date().toISOString().split("T")[0],
      supplier_id: "",
      retailer_name: "",
      retailer_mobile: "",
      retailer_address: "",
      return_type: "",
      enter_amount: "",
      paid: "0",
      pure: "0",
      opening: "0.000",
      current: "0.000",
      close: "0.000",
      total_pure: "0.000",
      items: [],
      manager: "",
      manager_name: "",
      staff: "",
    });
    resetNewItem();
    clearRetailer();
    setSearchTerm("");
    setReturnPureCalculated("0.000");
  };

  const closeModal = () => {
    setShowModal(false);
    handleClear();
    navigate(`/retailer-bill/${formData.retailer_id}`);
  };

  const fetchLoggedInUser = () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
      if (userInfo && userInfo.user_id) {
        setLoggedInUser(userInfo);
      }
    } catch (error) {
      console.error("Error reading logged-in user:", error);
    }
  };

  const fetchUserData = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/user.php`);
      const users = Array.isArray(res.data.data) ? res.data.data : [];
      setUserdata(users);
    } catch (err) {
      console.error("Failed to fetch users", err);
      toast.error("Failed to load staff data", 3000, 'topRight');
    }
  };

  useEffect(() => {
    if (!loggedInUser || userdata.length === 0) return;

    const currentUser = userdata.find(u => u.user_id === loggedInUser.user_id);
    if (!currentUser) return;

    if (currentUser.role === "Manager" || currentUser.role === "manager") {
      setSelectedManager(currentUser.id.toString());
      setIsManagerLocked(true);

      const allStaff = userdata.filter(
        u => u.role === "Employee" || u.role === "employee"
      );
      setStaffList(allStaff);

      setFormData(prev => ({
        ...prev,
        manager: currentUser.user_id,
        manager_name: currentUser.name,
      }));
    }
    else if (currentUser.role === "Employee" || currentUser.role === "employee") {
      // Employee: staff auto-filled & locked, manager is FREE dropdown (pick who is on duty)
      setSelectedStaff(currentUser.name);
      setIsStaffLocked(true);

      setFormData(prev => ({
        ...prev,
        staff: currentUser.name,
      }));

      const allStaff = userdata.filter(
        u => u.role === "Employee" || u.role === "employee"
      );
      setStaffList(allStaff);
    }
    // Admin → only manager dropdown shown, free choice
  }, [loggedInUser, userdata]);

  const handleManagerChange = (e) => {
    if (isManagerLocked) return;
    const managerId = e.target.value;
    setSelectedManager(managerId);

    if (managerId) {
      const managerObj = userdata.find(u => u.id === parseInt(managerId));
      if (managerObj) {
        const allStaff = userdata.filter(
          u => u.role === "Employee" || u.role === "employee"
        );
        setStaffList(allStaff);

        setFormData(prev => ({
          ...prev,
          manager: managerObj.user_id,
          manager_name: managerObj.name,
        }));
      }
    } else {
      setFormData(prev => ({ ...prev, manager: "", manager_name: "" }));
    }
  };

  const handleStaffChange = (e) => {
    if (isStaffLocked) return;
    const staffName = e.target.value;
    setSelectedStaff(staffName);
    setFormData(prev => ({ ...prev, staff: staffName }));
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}

      <div className="container-fluid py-2">
        {/* Header */}
        <div className="row">
          <div className="col-lg-3">
            <div className="card p-2">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Retailer No</label>
                  <input type="text" className="form-control" value={generateNumber} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.retailer_date}
                    onChange={(e) =>
                      setFormData((p) => ({ ...p, retailer_date: e.target.value }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Retailer Selection */}
          <div className="col-lg-9">
            <div className="card p-2">
              <div className="row g-3">
                <div className="col-md-3 position-relative">
                  <label className="form-label">Retailer</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search retailer..."
                      value={retailerSearchTerm}
                      onChange={(e) => {
                        setRetailerSearchTerm(e.target.value);
                        setShowRetailerDropdown(true);
                      }}
                      onFocus={() => setShowRetailerDropdown(true)}
                    />
                    {retailerSearchTerm && (
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        style={{ height: "35px" }}
                        onClick={clearRetailer}
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                    {!selectedRetailer && (
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        style={{ height: "35px" }}
                        onClick={openAddRetailerModal}
                        title="Add New Retailer"
                      >
                        <i className="bi bi-plus"></i>
                      </button>
                    )}
                  </div>

                  {showRetailerDropdown && retailers.length > 0 && (
                    <div className="dropdown-menu show w-100">
                      {retailers
                        .filter(
                          (retailer) =>
                            retailer.retailer_id
                              .toLowerCase()
                              .includes(retailerSearchTerm.toLowerCase()) ||
                            retailer.name
                              .toLowerCase()
                              .includes(retailerSearchTerm.toLowerCase())
                        )
                        .map((retailer) => (
                          <button
                            key={retailer.retailer_id}
                            className="dropdown-item"
                            onClick={() => handleSelectRetailer(retailer)}
                            type="button"
                          >
                            {retailer.retailer_id} - {retailer.name}
                          </button>
                        ))}
                    </div>
                  )}
                </div>

                <div className="col-md-3">
                  <label className="form-label">Retailer Name</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={formData.retailer_name}
                    readOnly
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Mobile</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={formData.retailer_mobile}
                    readOnly
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={formData.retailer_address}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          {(() => {
            const role = JSON.parse(localStorage.getItem("user") || "{}").role || "";
            const isAdmin = role === "Admin" || role === "admin";
            return (
              <>
                <div className="col-md-3">
                  <label className="form-label">
                    Manager <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={selectedManager}
                    onChange={handleManagerChange}
                    disabled={isManagerLocked}
                  >
                    <option value="">Select Manager</option>
                    {userdata
                      .filter(u => u.role === "Manager" || u.role === "manager")
                      .map(manager => (
                        <option key={manager.id} value={manager.id}>
                          {manager.name}
                        </option>
                      ))}
                  </select>
                </div>

                {!isAdmin && (
                  <div className="col-md-3">
                    <label className="form-label">
                      Staff
                    </label>
                    <select
                      className="form-select"
                      value={selectedStaff}
                      onChange={handleStaffChange}
                      disabled={isStaffLocked}
                    >
                      <option value="">Select Staff</option>
                      {staffList.map(staff => (
                        <option key={staff.id} value={staff.name}>
                          {staff.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </>
            );
          })()}
        </div>

        {/* Item Entry */}
        <div className="card mt-1 p-2">
          <div className="row g-3">
            <div className="col-md-2">
              <label>Item</label>
              <select
                className="form-select"
                value={newItem.item}
                onChange={(e) =>
                  setNewItem({
                    ...newItem,
                    item: e.target.value,
                    type: e.target.value === "Bar" ? "" : newItem.type,
                  })
                }
              >
                <option value="">Select</option>
                <option value="Bar">Bar</option>
                <option value="Jewels">Jewels</option>
                <option value="Others">Others</option>
              </select>
            </div>

            {newItem.item === "Others" && (
              <div className="col-md-2">
                <label>Others Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={newItem.other_name}
                  onChange={(e) => setNewItem({ ...newItem, other_name: e.target.value })}
                />
              </div>
            )}

            <div className="col-md-2">
              <label>Category</label>
              <select
                className="form-select"
                value={newItem.category}
                onChange={(e) => setNewItem({ ...newItem, category: e.target.value })}
              >
                <option value="">Select</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
                <option value="Gold Coin">Gold Coin</option>
                <option value="Silver Coin">Silver Coin</option>
              </select>
            </div>

            {/* Item Name dropdown - shows items from products table */}
<div className="col-md-2">
  <label>Item Name</label>
  <div className="d-flex align-items-center gap-1">
    <select 
      className="form-select" 
      value={newItem.item_name_english || ""} 
      onChange={(e) => {
        const selectedValue = e.target.value;
        const selected = filteredProducts.find(p => 
          (p.item_name_english || p.item_name) === selectedValue
        );
        setNewItem({
          ...newItem,
          item_name_english: selectedValue,
          item_name_tamil: selected?.item_name_tamil || "",
          type: selectedValue,
        });
      }}
      disabled={!newItem.category}
    >
      <option value="">Select Item Name</option>
      {filteredProducts.map((product) => {
        const displayName = product.item_name_tamil 
          ? `${product.item_name_english || product.item_name} / ${product.item_name_tamil}`
          : (product.item_name_english || product.item_name);
        return (
          <option key={product.id} value={product.item_name_english || product.item_name}>
            {displayName}
          </option>
        );
      })}
    </select>
    <button
      type="button"
      className="btn btn-outline-primary btn-sm"
      onClick={openProductModal}
      title="Add New Product"
      disabled={!newItem.category}
      style={{ height: "32px" }}
    >
      <i className="bi bi-plus"></i>
    </button>
  </div>
  {!newItem.category && filteredProducts.length === 0 && (
    <small className="text-muted text-danger d-block">Please select category first</small>
  )}
</div>

            <div className="col-md-1">
              <label>Weight (g)</label>
              <input
                type="text"
                className="form-control"
                value={newItem.weight}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value))
                    setNewItem({ ...newItem, weight: e.target.value });
                }}
              />
            </div>

            <div className="col-md-2 position-relative">
              <label>Adjustment</label>
              <div className="input-group">
                <button
                  className="btn btn-outline-danger btn-sm"
                  type="button"
                  style={{ height: "30px" }}
                  onClick={() => {
                    const v = parseFloat(adjustmentInput) || 0;
                    if (v > 0) {
                      setNewItem((p) => ({
                        ...p,
                        adjustment: (parseFloat(p.adjustment || 0) - v).toFixed(3),
                      }));
                      setAdjustmentInput("");
                    }
                  }}
                >
                  <i className="fa-solid fa-minus"></i>
                </button>

                <input
                  type="text"
                  className="form-control form-control-sm text-center"
                  value={adjustmentInput}
                  placeholder="0.000"
                  onChange={(e) => {
                    if (/^\d*\.?\d*$/.test(e.target.value)) setAdjustmentInput(e.target.value);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const v = parseFloat(adjustmentInput) || 0;
                      if (v > 0) {
                        setNewItem((p) => ({
                          ...p,
                          adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
                        }));
                        setAdjustmentInput("");
                      }
                    }
                  }}
                />

                <button
                  className="btn btn-outline-success btn-sm"
                  type="button"
                  style={{ height: "30px" }}
                  onClick={() => {
                    const v = parseFloat(adjustmentInput) || 0;
                    if (v > 0) {
                      setNewItem((p) => ({
                        ...p,
                        adjustment: (parseFloat(p.adjustment || 0) + v).toFixed(3),
                      }));
                      setAdjustmentInput("");
                    }
                  }}
                >
                  <i className="fa-solid fa-plus"></i>
                </button>

                {parseFloat(newItem.adjustment || 0) !== 0 && (
                  <button
                    className="btn btn-sm translate-middle-y me-1"
                    style={{ zIndex: 10, background: "none", border: "none", position: "relative", top: "10px", right: "50px" }}
                    onClick={() => setNewItem((p) => ({ ...p, adjustment: "0.000" }))}
                  >
                    <i className="fa-solid fa-xmark text-danger"></i>
                  </button>
                )}
              </div>
            </div>

            <div className="col-md-1">
              <label>Purity (%)</label>
              <input
                type="text"
                inputMode="decimal"
                className="form-control"
                value={newItem.purity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                    const num = parseFloat(value);
                    if (!value || num <= 100) {
                      setNewItem({ ...newItem, purity: value });
                    }
                  }
                }}
              />
            </div>

            <div className="col-md-1">
              <label>Pure (g)</label>
              <input type="text" className="form-control" value={newItem.pure} readOnly />
            </div>

            <div className="col-md-1 p-4">
              {editingItemId === null ? (
                <button className="btn btn-success btn-sm" onClick={handleAddItem}>
                  <i className="bi bi-plus"></i>
                </button>
              ) : (
                <button className="btn btn-info btn-sm" onClick={handleUpdateItem}>
                  <i className="bi bi-check"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Items Table + Summary */}
        <div className="row mt-2">
          <div className="col-lg-9">
            <div className="card p-2">
              <h6>Item List</h6>
              <table className="table table-sm">
                <thead className="bg-light">
                  <tr>
                    <th>S.No</th>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Cat</th>
                    <th>ItemName</th>
                    <th>Weight</th>
                    <th>Purity</th>
                    <th>Pure</th>
                    <th>Adjustment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.items.map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>
                        {item.item_name_tamil
                          ? `${item.item_name_english || item.item} / ${item.item_name_tamil}`
                          : item.item}
                        {item.other_name && ` (${item.other_name})`}
                      </td>
                      <td>{item.quantity}</td>
                      <td>{item.category}</td>
                      <td>
  {item.item_name_tamil
    ? `${item.item_name_english || item.item} / ${item.item_name_tamil}`
    : (item.item_name_english || item.item)}
  {item.other_name && ` (${item.other_name})`}
</td>
                      <td>{parseFloat(item.weight).toFixed(3)}</td>
                      <td>{parseFloat(item.purity).toFixed(2)}%</td>
                      <td>{parseFloat(item.pure).toFixed(3)}</td>
                      <td className="text-start">
                        <span className={item.adjustment > 0 ? "text-success" : item.adjustment < 0 ? "text-danger" : ""}>
                          {item.adjustment > 0 ? "+" : ""}
                          {parseFloat(item.adjustment || 0).toFixed(3)}
                        </span>
                      </td>
                      <td>
                        <button className="btn btn-sm btn-light" onClick={() => handleEditItem(item.id)}>
                          <i className="fa-solid fa-pen-to-square text-primary"></i>
                        </button>
                        <button className="btn btn-sm btn-light" onClick={() => handleRemoveItem(item.id)}>
                          <i className="fa-solid fa-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                  {formData.items.length === 0 && (
                    <tr><td colSpan="10" className="text-center">No items</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Summary */}
          <div className="col-lg-3">
            <div className="card p-3">
              <div className="row mb-2">
                <div className="col-6">Total Pure (g)</div>
                <div className="col-6">
                  <input type="text" className="form-control" value={formData.total_pure || "0.000"} readOnly />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-6">Return Type</div>
                <div className="col-6">
                  <select
                    className="form-select"
                    value={formData.return_type}
                    onChange={(e) => {
                      const newReturnType = e.target.value;
                      setFormData({
                        ...formData,
                        return_type: newReturnType,
                        pure: "",
                        paid: "",
                        enter_amount: "",
                      });
                      setReturnPureCalculated("0.000");
                    }}
                  >
                    <option value="">Select</option>
                    <option value="Pure">Pure</option>
                    <option value="Amount">Amount</option>
                  </select>
                </div>
              </div>

              {formData.return_type === "Pure" && (
                <div className="row mb-2">
                  <div className="col-6">
                    <label className="form-label">Return Pure (g)</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="0.000"
                      value={formData.pure}
                      onChange={(e) => {
                        if (/^\d*\.?\d*$/.test(e.target.value))
                          setFormData({ ...formData, pure: e.target.value });
                      }}
                    />
                  </div>
                </div>
              )}

              {formData.return_type === "Amount" && (
                <>
                  <div className="row mb-2">
                    <div className="col-6">
                      <label className="form-label">Paid (₹)</label>
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="0.00"
                        value={formData.paid}
                        onChange={(e) => {
                          if (/^\d*\.?\d*$/.test(e.target.value))
                            setFormData({ ...formData, paid: e.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-6">
                      <label className="form-label">Return Pure (g)</label>
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        className="form-control bg-light"
                        value={returnPureCalculated}
                        readOnly
                      />
                    </div>
                  </div>
                </>
              )}

              <hr className="my-2" />

              <div className="row mb-2">
                <div className="col-6">Opening (g)</div>
                <div className="col-6">
                  <input className="form-control bg-light" value={formData.opening || "0.000"} readOnly />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">Current (g)</div>
                <div className="col-6">
                  <input className="form-control bg-light" value={formData.current || "0.000"} readOnly />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">Closing (g)</div>
                <div className="col-6">
                  <input className="form-control bg-light" value={formData.close || "0.000"} readOnly />
                </div>
              </div>

              <div className="d-flex justify-content-between mt-3">
                <button className="btn btn-secondary btn-sm" onClick={() => navigate("/retailers")}>
                  Back
                </button>
                <button className="btn btn-danger btn-sm" onClick={handleClear}>
                  Clear
                </button>
                <button className="btn btn-primary btn-sm" onClick={handlePrint} disabled={loading}>
                  Print
                </button>
                <button className="btn btn-success btn-sm" onClick={handleSave} disabled={loading}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Modal */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h6>Print Confirmation</h6>
                  <button className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body text-center">
                  <p>Do you want to print the retailer bill?</p>
                  <button className="btn btn-secondary mx-2" onClick={() => navigate("/retailers")}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={closeModal}>
                    Print
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      {/* Add Retailer Modal */}
      <div
        className={`modal fade ${showAddRetailerModal ? "show" : ""}`}
        style={{
          display: showAddRetailerModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        onClick={() => setShowAddRetailerModal(false)}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: '500px' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title text-primary">Add New Retailer</h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeAddRetailerModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Retailer ID</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  value={newRetailerId}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Name"
                  value={addData.name}
                  onChange={(e) => setAddData({ ...addData, name: e.target.value })}
                />
                {formErrors.name && (
                  <div className="invalid-feedback">{formErrors.name}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Mobile Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="10"
                  className={`form-control ${formErrors.mobile ? "is-invalid" : ""}`}
                  placeholder="Enter 10-digit Mobile"
                  value={addData.mobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      setAddData({ ...addData, mobile: value });
                    }
                  }}
                />
                {formErrors.mobile && (
                  <div className="invalid-feedback">{formErrors.mobile}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Address <span className="text-danger">*</span>
                </label>
                <textarea
                  className={`form-control ${formErrors.address ? "is-invalid" : ""}`}
                  placeholder="Enter Address"
                  rows="2"
                  value={addData.address}
                  onChange={(e) => setAddData({ ...addData, address: e.target.value })}
                />
                {formErrors.address && (
                  <div className="invalid-feedback">{formErrors.address}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${formErrors.status ? "is-invalid" : ""}`}
                  value={addData.status}
                  onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                {formErrors.status && (
                  <div className="invalid-feedback">{formErrors.status}</div>
                )}
              </div>

              <div className="d-flex gap-2 justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={closeAddRetailerModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleAddRetailerSubmit}
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
  className={`modal fade ${showProductModal ? "show" : ""}`}
  style={{
    display: showProductModal ? "block" : "none",
    backgroundColor: "rgba(0,0,0,0.5)",
  }}
  tabIndex="-1"
  aria-labelledby="addProductModalLabel"
  aria-hidden={!showProductModal}
  onClick={() => !loading && closeProductModal()}
>
  <div
    className="modal-dialog modal-dialog-centered"
    style={{ maxWidth: '600px' }}
    onClick={(e) => e.stopPropagation()}
  >
    <div className="modal-content">
      <div className="modal-header">
        <h6 className="modal-title text-primary" id="addProductModalLabel">
          Add Product
        </h6>
        <button
          type="button"
          className="btn-close"
          style={{ fontSize: "10px" }}
          onClick={closeProductModal}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleProductSubmit}>
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="item_code" className="form-label">
                  Item Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="item_code"
                  value={productAddData.item_code}
                  disabled
                  readOnly
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="product_category" className="form-label">
                  Category <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${productFormErrors.category ? "is-invalid" : ""}`}
                  id="product_category"
                  value={productAddData.category}
                  onChange={(e) =>
                    setProductAddData({
                      ...productAddData,
                      category: e.target.value,
                    })
                  }
                >
                  <option value="">Select Category</option>
                  <option value="Gold">Gold</option>
                  <option value="Silver">Silver</option>
                  <option value="Gold Coin">Gold Coin</option>
                  <option value="Silver Coin">Silver Coin</option>
                </select>
                {productFormErrors.category && (
                  <div className="invalid-feedback">
                    {productFormErrors.category}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="mb-3">
                <label htmlFor="item_name_english" className="form-label">
                  Item Name <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className={`form-control ${productFormErrors.item_name ? "is-invalid" : ""}`}
                    id="item_name_english"
                    placeholder="Enter item name in English (Tamil will auto-translate)"
                    value={productAddData.item_name_english}
                    onChange={(e) =>
                      setProductAddData({
                        ...productAddData,
                        item_name_english: e.target.value,
                        item_name: e.target.value,
                        item_name_tamil: "",
                      })
                    }
                    onBlur={async (e) => {
                      const val = e.target.value.trim();
                      if (val && !productAddData.item_name_tamil) {
                        const tamil = await translateToTamil(val);
                        if (tamil) {
                          setProductAddData((prev) => ({
                            ...prev,
                            item_name_tamil: tamil,
                          }));
                          toast.info(`Tamil translation: ${tamil}`, 2000, "topRight");
                        }
                      }
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    title="Translate to Tamil"
                    style={{ height: "38px" }}
                    disabled={isTranslating || !productAddData.item_name_english}
                    onClick={async () => {
                      const tamil = await translateToTamil(productAddData.item_name_english);
                      if (tamil) {
                        setProductAddData((prev) => ({
                          ...prev,
                          item_name_tamil: tamil,
                        }));
                        toast.success("Translated successfully!", 1500, "topRight");
                      } else {
                        toast.error("Translation failed. Please try again.", 2000, "topRight");
                      }
                    }}
                  >
                    {isTranslating ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      "🌐 Translate"
                    )}
                  </button>
                </div>
                {productAddData.item_name_tamil && (
                  <small className="text-muted mt-1 d-block">
                    <strong>Tamil:</strong> {productAddData.item_name_tamil}
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 ms-2 text-muted"
                      onClick={() =>
                        setProductAddData((prev) => ({
                          ...prev,
                          item_name_tamil: "",
                        }))
                      }
                    >
                      ✕ clear
                    </button>
                  </small>
                )}
                {productFormErrors.item_name && (
                  <div className="invalid-feedback">
                    {productFormErrors.item_name}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="pure_percent" className="form-label">
                  Purity (%) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="100"
                  className={`form-control ${productFormErrors.pure_percent ? "is-invalid" : ""}`}
                  id="pure_percent"
                  placeholder="e.g. 99.9"
                  value={productAddData.pure_percent}
                  onChange={(e) =>
                    setProductAddData({
                      ...productAddData,
                      pure_percent: e.target.value,
                    })
                  }
                />
                {productFormErrors.pure_percent && (
                  <div className="invalid-feedback">
                    {productFormErrors.pure_percent}
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="product_status" className="form-label">
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${productFormErrors.status ? "is-invalid" : ""}`}
                  id="product_status"
                  value={productAddData.status}
                  onChange={(e) =>
                    setProductAddData({
                      ...productAddData,
                      status: e.target.value,
                    })
                  }
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
                {productFormErrors.status && (
                  <div className="invalid-feedback">
                    {productFormErrors.status}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="mb-3">
              <label htmlFor="product_image" className="form-label">
                Image Upload
              </label>
              <input
                type="file"
                className="form-control"
                id="product_image"
                onChange={(e) =>
                  setProductAddData({
                    ...productAddData,
                    image: e.target.files[0],
                  })
                }
                accept="image/*"
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn btn-primary btn-sm px-4"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Product"}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

      {(showModal || showAddRetailerModal || showProductModal) && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default AddRetailer;